import { ASSESSMENT_DOCUMENT_FAILURE_REASONS as tt, ASSESSMENT_STAGE_PROGRESS_STATES as ot, ASSESSMENT_STAGE_KEYS as be, ASSESSMENT_DOCUMENT_PROGRESS_STATES as rt, MaturityLevelKey as ln, ALLOWED_DOCUMENT_CONTENT_TYPES as it, AssessmentDocumentStatus as st, DocumentClassificationCoverage as dn, DocumentClassificationInvalidReason as at, ClassificationConfidence as Ze, DocumentClassificationStatus as ue, LanguageCode as re, RemediationDecision as O, RemediationItemType as ce, RemediationContentKind as ke, SUPPORTED_LANGUAGES as ut, TenantProfileClassificationStatus as we, TenantProfileExtractionStatus as ye } from "@libs/constants";
function c(e, n, t) {
  function o(u, l) {
    var f;
    Object.defineProperty(u, "_zod", {
      value: u._zod ?? {},
      enumerable: !1
    }), (f = u._zod).traits ?? (f.traits = /* @__PURE__ */ new Set()), u._zod.traits.add(e), n(u, l);
    for (const v in a.prototype)
      v in u || Object.defineProperty(u, v, { value: a.prototype[v].bind(u) });
    u._zod.constr = a, u._zod.def = l;
  }
  const r = (t == null ? void 0 : t.Parent) ?? Object;
  class s extends r {
  }
  Object.defineProperty(s, "name", { value: e });
  function a(u) {
    var l;
    const f = t != null && t.Parent ? new s() : this;
    o(f, u), (l = f._zod).deferred ?? (l.deferred = []);
    for (const v of f._zod.deferred)
      v();
    return f;
  }
  return Object.defineProperty(a, "init", { value: o }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (u) => {
      var l, f;
      return t != null && t.Parent && u instanceof t.Parent ? !0 : (f = (l = u == null ? void 0 : u._zod) == null ? void 0 : l.traits) == null ? void 0 : f.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class q extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class mn extends Error {
  constructor(n) {
    super(`Encountered unidirectional transform during encode: ${n}`), this.name = "ZodEncodeError";
  }
}
const hn = {};
function L(e) {
  return hn;
}
function ct(e) {
  const n = Object.values(e).filter((o) => typeof o == "number");
  return Object.entries(e).filter(([o, r]) => n.indexOf(+o) === -1).map(([o, r]) => r);
}
function Ee(e, n) {
  return typeof n == "bigint" ? n.toString() : n;
}
function fe(e) {
  return {
    get value() {
      {
        const n = e();
        return Object.defineProperty(this, "value", { value: n }), n;
      }
    }
  };
}
function Re(e) {
  return e == null;
}
function $e(e) {
  const n = e.startsWith("^") ? 1 : 0, t = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(n, t);
}
function lt(e, n) {
  const t = (e.toString().split(".")[1] || "").length, o = n.toString();
  let r = (o.split(".")[1] || "").length;
  if (r === 0 && /\d?e-\d?/.test(o)) {
    const l = o.match(/\d?e-(\d?)/);
    l != null && l[1] && (r = Number.parseInt(l[1]));
  }
  const s = t > r ? t : r, a = Number.parseInt(e.toFixed(s).replace(".", "")), u = Number.parseInt(n.toFixed(s).replace(".", ""));
  return a % u / 10 ** s;
}
const je = Symbol("evaluating");
function S(e, n, t) {
  let o;
  Object.defineProperty(e, n, {
    get() {
      if (o !== je)
        return o === void 0 && (o = je, o = t()), o;
    },
    set(r) {
      Object.defineProperty(e, n, {
        value: r
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function K(e, n, t) {
  Object.defineProperty(e, n, {
    value: t,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function F(...e) {
  const n = {};
  for (const t of e) {
    const o = Object.getOwnPropertyDescriptors(t);
    Object.assign(n, o);
  }
  return Object.defineProperties({}, n);
}
function Me(e) {
  return JSON.stringify(e);
}
const fn = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function ne(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const dt = fe(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const n = Function;
    return new n(""), !0;
  } catch {
    return !1;
  }
});
function J(e) {
  if (ne(e) === !1)
    return !1;
  const n = e.constructor;
  if (n === void 0)
    return !0;
  const t = n.prototype;
  return !(ne(t) === !1 || Object.prototype.hasOwnProperty.call(t, "isPrototypeOf") === !1);
}
function pn(e) {
  return J(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const mt = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function H(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function U(e, n, t) {
  const o = new e._zod.constr(n ?? e._zod.def);
  return (!n || t != null && t.parent) && (o._zod.parent = e), o;
}
function p(e) {
  const n = e;
  if (!n)
    return {};
  if (typeof n == "string")
    return { error: () => n };
  if ((n == null ? void 0 : n.message) !== void 0) {
    if ((n == null ? void 0 : n.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    n.error = n.message;
  }
  return delete n.message, typeof n.error == "string" ? { ...n, error: () => n.error } : n;
}
function ht(e) {
  return Object.keys(e).filter((n) => e[n]._zod.optin === "optional" && e[n]._zod.optout === "optional");
}
const ft = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function pt(e, n) {
  const t = e._zod.def, o = F(e._zod.def, {
    get shape() {
      const r = {};
      for (const s in n) {
        if (!(s in t.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        n[s] && (r[s] = t.shape[s]);
      }
      return K(this, "shape", r), r;
    },
    checks: []
  });
  return U(e, o);
}
function _t(e, n) {
  const t = e._zod.def, o = F(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape };
      for (const s in n) {
        if (!(s in t.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        n[s] && delete r[s];
      }
      return K(this, "shape", r), r;
    },
    checks: []
  });
  return U(e, o);
}
function gt(e, n) {
  if (!J(n))
    throw new Error("Invalid input to extend: expected a plain object");
  const t = e._zod.def.checks;
  if (t && t.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const r = F(e._zod.def, {
    get shape() {
      const s = { ...e._zod.def.shape, ...n };
      return K(this, "shape", s), s;
    },
    checks: []
  });
  return U(e, r);
}
function vt(e, n) {
  if (!J(n))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const t = {
    ...e._zod.def,
    get shape() {
      const o = { ...e._zod.def.shape, ...n };
      return K(this, "shape", o), o;
    },
    checks: e._zod.def.checks
  };
  return U(e, t);
}
function St(e, n) {
  const t = F(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...n._zod.def.shape };
      return K(this, "shape", o), o;
    },
    get catchall() {
      return n._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return U(e, t);
}
function bt(e, n, t) {
  const o = F(n._zod.def, {
    get shape() {
      const r = n._zod.def.shape, s = { ...r };
      if (t)
        for (const a in t) {
          if (!(a in r))
            throw new Error(`Unrecognized key: "${a}"`);
          t[a] && (s[a] = e ? new e({
            type: "optional",
            innerType: r[a]
          }) : r[a]);
        }
      else
        for (const a in r)
          s[a] = e ? new e({
            type: "optional",
            innerType: r[a]
          }) : r[a];
      return K(this, "shape", s), s;
    },
    checks: []
  });
  return U(n, o);
}
function kt(e, n, t) {
  const o = F(n._zod.def, {
    get shape() {
      const r = n._zod.def.shape, s = { ...r };
      if (t)
        for (const a in t) {
          if (!(a in s))
            throw new Error(`Unrecognized key: "${a}"`);
          t[a] && (s[a] = new e({
            type: "nonoptional",
            innerType: r[a]
          }));
        }
      else
        for (const a in r)
          s[a] = new e({
            type: "nonoptional",
            innerType: r[a]
          });
      return K(this, "shape", s), s;
    },
    checks: []
  });
  return U(n, o);
}
function W(e, n = 0) {
  var t;
  if (e.aborted === !0)
    return !0;
  for (let o = n; o < e.issues.length; o++)
    if (((t = e.issues[o]) == null ? void 0 : t.continue) !== !0)
      return !0;
  return !1;
}
function B(e, n) {
  return n.map((t) => {
    var o;
    return (o = t).path ?? (o.path = []), t.path.unshift(e), t;
  });
}
function ie(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function j(e, n, t) {
  var r, s, a, u, l, f;
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const v = ie((a = (s = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : s.error) == null ? void 0 : a.call(s, e)) ?? ie((u = n == null ? void 0 : n.error) == null ? void 0 : u.call(n, e)) ?? ie((l = t.customError) == null ? void 0 : l.call(t, e)) ?? ie((f = t.localeError) == null ? void 0 : f.call(t, e)) ?? "Invalid input";
    o.message = v;
  }
  return delete o.inst, delete o.continue, n != null && n.reportInput || delete o.input, o;
}
function Te(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function te(...e) {
  const [n, t, o] = e;
  return typeof n == "string" ? {
    message: n,
    code: "custom",
    input: t,
    inst: o
  } : { ...n };
}
const _n = (e, n) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: n,
    enumerable: !1
  }), e.message = JSON.stringify(n, Ee, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, gn = c("$ZodError", _n), vn = c("$ZodError", _n, { Parent: Error });
function wt(e, n = (t) => t.message) {
  const t = {}, o = [];
  for (const r of e.issues)
    r.path.length > 0 ? (t[r.path[0]] = t[r.path[0]] || [], t[r.path[0]].push(n(r))) : o.push(n(r));
  return { formErrors: o, fieldErrors: t };
}
function yt(e, n = (t) => t.message) {
  const t = { _errors: [] }, o = (r) => {
    for (const s of r.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((a) => o({ issues: a }));
      else if (s.code === "invalid_key")
        o({ issues: s.issues });
      else if (s.code === "invalid_element")
        o({ issues: s.issues });
      else if (s.path.length === 0)
        t._errors.push(n(s));
      else {
        let a = t, u = 0;
        for (; u < s.path.length; ) {
          const l = s.path[u];
          u === s.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(n(s))) : a[l] = a[l] || { _errors: [] }, a = a[l], u++;
        }
      }
  };
  return o(e), t;
}
const Ce = (e) => (n, t, o, r) => {
  const s = o ? Object.assign(o, { async: !1 }) : { async: !1 }, a = n._zod.run({ value: t, issues: [] }, s);
  if (a instanceof Promise)
    throw new q();
  if (a.issues.length) {
    const u = new ((r == null ? void 0 : r.Err) ?? e)(a.issues.map((l) => j(l, s, L())));
    throw fn(u, r == null ? void 0 : r.callee), u;
  }
  return a.value;
}, Ne = (e) => async (n, t, o, r) => {
  const s = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let a = n._zod.run({ value: t, issues: [] }, s);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const u = new ((r == null ? void 0 : r.Err) ?? e)(a.issues.map((l) => j(l, s, L())));
    throw fn(u, r == null ? void 0 : r.callee), u;
  }
  return a.value;
}, pe = (e) => (n, t, o) => {
  const r = o ? { ...o, async: !1 } : { async: !1 }, s = n._zod.run({ value: t, issues: [] }, r);
  if (s instanceof Promise)
    throw new q();
  return s.issues.length ? {
    success: !1,
    error: new (e ?? gn)(s.issues.map((a) => j(a, r, L())))
  } : { success: !0, data: s.value };
}, Et = /* @__PURE__ */ pe(vn), _e = (e) => async (n, t, o) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let s = n._zod.run({ value: t, issues: [] }, r);
  return s instanceof Promise && (s = await s), s.issues.length ? {
    success: !1,
    error: new e(s.issues.map((a) => j(a, r, L())))
  } : { success: !0, data: s.value };
}, zt = /* @__PURE__ */ _e(vn), At = (e) => (n, t, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Ce(e)(n, t, r);
}, It = (e) => (n, t, o) => Ce(e)(n, t, o), Zt = (e) => async (n, t, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Ne(e)(n, t, r);
}, Rt = (e) => async (n, t, o) => Ne(e)(n, t, o), $t = (e) => (n, t, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return pe(e)(n, t, r);
}, Tt = (e) => (n, t, o) => pe(e)(n, t, o), Ct = (e) => async (n, t, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return _e(e)(n, t, r);
}, Nt = (e) => async (n, t, o) => _e(e)(n, t, o), Dt = /^[cC][^\s-]{8,}$/, Pt = /^[0-9a-z]+$/, Ot = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, xt = /^[0-9a-vA-V]{20}$/, Ut = /^[A-Za-z0-9]{27}$/, Lt = /^[a-zA-Z0-9_-]{21}$/, jt = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Mt = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Ke = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Kt = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Ft = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Gt() {
  return new RegExp(Ft, "u");
}
const Vt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Wt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Bt = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, qt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Jt = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Sn = /^[A-Za-z0-9_-]*$/, Ht = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Xt = /^\+(?:[0-9]){6,14}[0-9]$/, bn = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Yt = /* @__PURE__ */ new RegExp(`^${bn}$`);
function kn(e) {
  const n = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${n}` : e.precision === 0 ? `${n}:[0-5]\\d` : `${n}:[0-5]\\d\\.\\d{${e.precision}}` : `${n}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Qt(e) {
  return new RegExp(`^${kn(e)}$`);
}
function eo(e) {
  const n = kn({ precision: e.precision }), t = ["Z"];
  e.local && t.push(""), e.offset && t.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${n}(?:${t.join("|")})`;
  return new RegExp(`^${bn}T(?:${o})$`);
}
const no = (e) => {
  const n = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${n}$`);
}, to = /^-?\d+$/, oo = /^-?\d+(?:\.\d+)?/, ro = /^(?:true|false)$/i, io = /^null$/i, so = /^[^A-Z]*$/, ao = /^[^a-z]*$/, R = /* @__PURE__ */ c("$ZodCheck", (e, n) => {
  var t;
  e._zod ?? (e._zod = {}), e._zod.def = n, (t = e._zod).onattach ?? (t.onattach = []);
}), wn = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, yn = /* @__PURE__ */ c("$ZodCheckLessThan", (e, n) => {
  R.init(e, n);
  const t = wn[typeof n.value];
  e._zod.onattach.push((o) => {
    const r = o._zod.bag, s = (n.inclusive ? r.maximum : r.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    n.value < s && (n.inclusive ? r.maximum = n.value : r.exclusiveMaximum = n.value);
  }), e._zod.check = (o) => {
    (n.inclusive ? o.value <= n.value : o.value < n.value) || o.issues.push({
      origin: t,
      code: "too_big",
      maximum: n.value,
      input: o.value,
      inclusive: n.inclusive,
      inst: e,
      continue: !n.abort
    });
  };
}), En = /* @__PURE__ */ c("$ZodCheckGreaterThan", (e, n) => {
  R.init(e, n);
  const t = wn[typeof n.value];
  e._zod.onattach.push((o) => {
    const r = o._zod.bag, s = (n.inclusive ? r.minimum : r.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    n.value > s && (n.inclusive ? r.minimum = n.value : r.exclusiveMinimum = n.value);
  }), e._zod.check = (o) => {
    (n.inclusive ? o.value >= n.value : o.value > n.value) || o.issues.push({
      origin: t,
      code: "too_small",
      minimum: n.value,
      input: o.value,
      inclusive: n.inclusive,
      inst: e,
      continue: !n.abort
    });
  };
}), uo = /* @__PURE__ */ c("$ZodCheckMultipleOf", (e, n) => {
  R.init(e, n), e._zod.onattach.push((t) => {
    var o;
    (o = t._zod.bag).multipleOf ?? (o.multipleOf = n.value);
  }), e._zod.check = (t) => {
    if (typeof t.value != typeof n.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof t.value == "bigint" ? t.value % n.value === BigInt(0) : lt(t.value, n.value) === 0) || t.issues.push({
      origin: typeof t.value,
      code: "not_multiple_of",
      divisor: n.value,
      input: t.value,
      inst: e,
      continue: !n.abort
    });
  };
}), co = /* @__PURE__ */ c("$ZodCheckNumberFormat", (e, n) => {
  var a;
  R.init(e, n), n.format = n.format || "float64";
  const t = (a = n.format) == null ? void 0 : a.includes("int"), o = t ? "int" : "number", [r, s] = ft[n.format];
  e._zod.onattach.push((u) => {
    const l = u._zod.bag;
    l.format = n.format, l.minimum = r, l.maximum = s, t && (l.pattern = to);
  }), e._zod.check = (u) => {
    const l = u.value;
    if (t) {
      if (!Number.isInteger(l)) {
        u.issues.push({
          expected: o,
          format: n.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? u.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          continue: !n.abort
        }) : u.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          continue: !n.abort
        });
        return;
      }
    }
    l < r && u.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: r,
      inclusive: !0,
      inst: e,
      continue: !n.abort
    }), l > s && u.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: s,
      inst: e
    });
  };
}), lo = /* @__PURE__ */ c("$ZodCheckMaxLength", (e, n) => {
  var t;
  R.init(e, n), (t = e._zod.def).when ?? (t.when = (o) => {
    const r = o.value;
    return !Re(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    n.maximum < r && (o._zod.bag.maximum = n.maximum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length <= n.maximum)
      return;
    const a = Te(r);
    o.issues.push({
      origin: a,
      code: "too_big",
      maximum: n.maximum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !n.abort
    });
  };
}), mo = /* @__PURE__ */ c("$ZodCheckMinLength", (e, n) => {
  var t;
  R.init(e, n), (t = e._zod.def).when ?? (t.when = (o) => {
    const r = o.value;
    return !Re(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    n.minimum > r && (o._zod.bag.minimum = n.minimum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length >= n.minimum)
      return;
    const a = Te(r);
    o.issues.push({
      origin: a,
      code: "too_small",
      minimum: n.minimum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !n.abort
    });
  };
}), ho = /* @__PURE__ */ c("$ZodCheckLengthEquals", (e, n) => {
  var t;
  R.init(e, n), (t = e._zod.def).when ?? (t.when = (o) => {
    const r = o.value;
    return !Re(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.minimum = n.length, r.maximum = n.length, r.length = n.length;
  }), e._zod.check = (o) => {
    const r = o.value, s = r.length;
    if (s === n.length)
      return;
    const a = Te(r), u = s > n.length;
    o.issues.push({
      origin: a,
      ...u ? { code: "too_big", maximum: n.length } : { code: "too_small", minimum: n.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !n.abort
    });
  };
}), ge = /* @__PURE__ */ c("$ZodCheckStringFormat", (e, n) => {
  var t, o;
  R.init(e, n), e._zod.onattach.push((r) => {
    const s = r._zod.bag;
    s.format = n.format, n.pattern && (s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(n.pattern));
  }), n.pattern ? (t = e._zod).check ?? (t.check = (r) => {
    n.pattern.lastIndex = 0, !n.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: n.format,
      input: r.value,
      ...n.pattern ? { pattern: n.pattern.toString() } : {},
      inst: e,
      continue: !n.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), fo = /* @__PURE__ */ c("$ZodCheckRegex", (e, n) => {
  ge.init(e, n), e._zod.check = (t) => {
    n.pattern.lastIndex = 0, !n.pattern.test(t.value) && t.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: t.value,
      pattern: n.pattern.toString(),
      inst: e,
      continue: !n.abort
    });
  };
}), po = /* @__PURE__ */ c("$ZodCheckLowerCase", (e, n) => {
  n.pattern ?? (n.pattern = so), ge.init(e, n);
}), _o = /* @__PURE__ */ c("$ZodCheckUpperCase", (e, n) => {
  n.pattern ?? (n.pattern = ao), ge.init(e, n);
}), go = /* @__PURE__ */ c("$ZodCheckIncludes", (e, n) => {
  R.init(e, n);
  const t = H(n.includes), o = new RegExp(typeof n.position == "number" ? `^.{${n.position}}${t}` : t);
  n.pattern = o, e._zod.onattach.push((r) => {
    const s = r._zod.bag;
    s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(o);
  }), e._zod.check = (r) => {
    r.value.includes(n.includes, n.position) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: n.includes,
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), vo = /* @__PURE__ */ c("$ZodCheckStartsWith", (e, n) => {
  R.init(e, n);
  const t = new RegExp(`^${H(n.prefix)}.*`);
  n.pattern ?? (n.pattern = t), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(t);
  }), e._zod.check = (o) => {
    o.value.startsWith(n.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: n.prefix,
      input: o.value,
      inst: e,
      continue: !n.abort
    });
  };
}), So = /* @__PURE__ */ c("$ZodCheckEndsWith", (e, n) => {
  R.init(e, n);
  const t = new RegExp(`.*${H(n.suffix)}$`);
  n.pattern ?? (n.pattern = t), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(t);
  }), e._zod.check = (o) => {
    o.value.endsWith(n.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: n.suffix,
      input: o.value,
      inst: e,
      continue: !n.abort
    });
  };
}), bo = /* @__PURE__ */ c("$ZodCheckOverwrite", (e, n) => {
  R.init(e, n), e._zod.check = (t) => {
    t.value = n.tx(t.value);
  };
});
class ko {
  constructor(n = []) {
    this.content = [], this.indent = 0, this && (this.args = n);
  }
  indented(n) {
    this.indent += 1, n(this), this.indent -= 1;
  }
  write(n) {
    if (typeof n == "function") {
      n(this, { execution: "sync" }), n(this, { execution: "async" });
      return;
    }
    const o = n.split(`
`).filter((a) => a), r = Math.min(...o.map((a) => a.length - a.trimStart().length)), s = o.map((a) => a.slice(r)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of s)
      this.content.push(a);
  }
  compile() {
    const n = Function, t = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((s) => `  ${s}`)];
    return new n(...t, r.join(`
`));
  }
}
const wo = {
  major: 4,
  minor: 1,
  patch: 12
}, b = /* @__PURE__ */ c("$ZodType", (e, n) => {
  var r;
  var t;
  e ?? (e = {}), e._zod.def = n, e._zod.bag = e._zod.bag || {}, e._zod.version = wo;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const s of o)
    for (const a of s._zod.onattach)
      a(e);
  if (o.length === 0)
    (t = e._zod).deferred ?? (t.deferred = []), (r = e._zod.deferred) == null || r.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const s = (u, l, f) => {
      let v = W(u), E;
      for (const z of l) {
        if (z._zod.def.when) {
          if (!z._zod.def.when(u))
            continue;
        } else if (v)
          continue;
        const A = u.issues.length, Z = z._zod.check(u);
        if (Z instanceof Promise && (f == null ? void 0 : f.async) === !1)
          throw new q();
        if (E || Z instanceof Promise)
          E = (E ?? Promise.resolve()).then(async () => {
            await Z, u.issues.length !== A && (v || (v = W(u, A)));
          });
        else {
          if (u.issues.length === A)
            continue;
          v || (v = W(u, A));
        }
      }
      return E ? E.then(() => u) : u;
    }, a = (u, l, f) => {
      if (W(u))
        return u.aborted = !0, u;
      const v = s(l, o, f);
      if (v instanceof Promise) {
        if (f.async === !1)
          throw new q();
        return v.then((E) => e._zod.parse(E, f));
      }
      return e._zod.parse(v, f);
    };
    e._zod.run = (u, l) => {
      if (l.skipChecks)
        return e._zod.parse(u, l);
      if (l.direction === "backward") {
        const v = e._zod.parse({ value: u.value, issues: [] }, { ...l, skipChecks: !0 });
        return v instanceof Promise ? v.then((E) => a(E, u, l)) : a(v, u, l);
      }
      const f = e._zod.parse(u, l);
      if (f instanceof Promise) {
        if (l.async === !1)
          throw new q();
        return f.then((v) => s(v, o, l));
      }
      return s(f, o, l);
    };
  }
  e["~standard"] = {
    validate: (s) => {
      var a;
      try {
        const u = Et(e, s);
        return u.success ? { value: u.data } : { issues: (a = u.error) == null ? void 0 : a.issues };
      } catch {
        return zt(e, s).then((l) => {
          var f;
          return l.success ? { value: l.data } : { issues: (f = l.error) == null ? void 0 : f.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
}), De = /* @__PURE__ */ c("$ZodString", (e, n) => {
  var t;
  b.init(e, n), e._zod.pattern = [...((t = e == null ? void 0 : e._zod.bag) == null ? void 0 : t.patterns) ?? []].pop() ?? no(e._zod.bag), e._zod.parse = (o, r) => {
    if (n.coerce)
      try {
        o.value = String(o.value);
      } catch {
      }
    return typeof o.value == "string" || o.issues.push({
      expected: "string",
      code: "invalid_type",
      input: o.value,
      inst: e
    }), o;
  };
}), k = /* @__PURE__ */ c("$ZodStringFormat", (e, n) => {
  ge.init(e, n), De.init(e, n);
}), yo = /* @__PURE__ */ c("$ZodGUID", (e, n) => {
  n.pattern ?? (n.pattern = Mt), k.init(e, n);
}), Eo = /* @__PURE__ */ c("$ZodUUID", (e, n) => {
  if (n.version) {
    const o = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[n.version];
    if (o === void 0)
      throw new Error(`Invalid UUID version: "${n.version}"`);
    n.pattern ?? (n.pattern = Ke(o));
  } else
    n.pattern ?? (n.pattern = Ke());
  k.init(e, n);
}), zo = /* @__PURE__ */ c("$ZodEmail", (e, n) => {
  n.pattern ?? (n.pattern = Kt), k.init(e, n);
}), Ao = /* @__PURE__ */ c("$ZodURL", (e, n) => {
  k.init(e, n), e._zod.check = (t) => {
    try {
      const o = t.value.trim(), r = new URL(o);
      n.hostname && (n.hostname.lastIndex = 0, n.hostname.test(r.hostname) || t.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Ht.source,
        input: t.value,
        inst: e,
        continue: !n.abort
      })), n.protocol && (n.protocol.lastIndex = 0, n.protocol.test(r.protocol.endsWith(":") ? r.protocol.slice(0, -1) : r.protocol) || t.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: n.protocol.source,
        input: t.value,
        inst: e,
        continue: !n.abort
      })), n.normalize ? t.value = r.href : t.value = o;
      return;
    } catch {
      t.issues.push({
        code: "invalid_format",
        format: "url",
        input: t.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
}), Io = /* @__PURE__ */ c("$ZodEmoji", (e, n) => {
  n.pattern ?? (n.pattern = Gt()), k.init(e, n);
}), Zo = /* @__PURE__ */ c("$ZodNanoID", (e, n) => {
  n.pattern ?? (n.pattern = Lt), k.init(e, n);
}), Ro = /* @__PURE__ */ c("$ZodCUID", (e, n) => {
  n.pattern ?? (n.pattern = Dt), k.init(e, n);
}), $o = /* @__PURE__ */ c("$ZodCUID2", (e, n) => {
  n.pattern ?? (n.pattern = Pt), k.init(e, n);
}), To = /* @__PURE__ */ c("$ZodULID", (e, n) => {
  n.pattern ?? (n.pattern = Ot), k.init(e, n);
}), Co = /* @__PURE__ */ c("$ZodXID", (e, n) => {
  n.pattern ?? (n.pattern = xt), k.init(e, n);
}), No = /* @__PURE__ */ c("$ZodKSUID", (e, n) => {
  n.pattern ?? (n.pattern = Ut), k.init(e, n);
}), Do = /* @__PURE__ */ c("$ZodISODateTime", (e, n) => {
  n.pattern ?? (n.pattern = eo(n)), k.init(e, n);
}), Po = /* @__PURE__ */ c("$ZodISODate", (e, n) => {
  n.pattern ?? (n.pattern = Yt), k.init(e, n);
}), Oo = /* @__PURE__ */ c("$ZodISOTime", (e, n) => {
  n.pattern ?? (n.pattern = Qt(n)), k.init(e, n);
}), xo = /* @__PURE__ */ c("$ZodISODuration", (e, n) => {
  n.pattern ?? (n.pattern = jt), k.init(e, n);
}), Uo = /* @__PURE__ */ c("$ZodIPv4", (e, n) => {
  n.pattern ?? (n.pattern = Vt), k.init(e, n), e._zod.onattach.push((t) => {
    const o = t._zod.bag;
    o.format = "ipv4";
  });
}), Lo = /* @__PURE__ */ c("$ZodIPv6", (e, n) => {
  n.pattern ?? (n.pattern = Wt), k.init(e, n), e._zod.onattach.push((t) => {
    const o = t._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (t) => {
    try {
      new URL(`http://[${t.value}]`);
    } catch {
      t.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: t.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
}), jo = /* @__PURE__ */ c("$ZodCIDRv4", (e, n) => {
  n.pattern ?? (n.pattern = Bt), k.init(e, n);
}), Mo = /* @__PURE__ */ c("$ZodCIDRv6", (e, n) => {
  n.pattern ?? (n.pattern = qt), k.init(e, n), e._zod.check = (t) => {
    const o = t.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [r, s] = o;
      if (!s)
        throw new Error();
      const a = Number(s);
      if (`${a}` !== s)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${r}]`);
    } catch {
      t.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: t.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
});
function zn(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Ko = /* @__PURE__ */ c("$ZodBase64", (e, n) => {
  n.pattern ?? (n.pattern = Jt), k.init(e, n), e._zod.onattach.push((t) => {
    t._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (t) => {
    zn(t.value) || t.issues.push({
      code: "invalid_format",
      format: "base64",
      input: t.value,
      inst: e,
      continue: !n.abort
    });
  };
});
function Fo(e) {
  if (!Sn.test(e))
    return !1;
  const n = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), t = n.padEnd(Math.ceil(n.length / 4) * 4, "=");
  return zn(t);
}
const Go = /* @__PURE__ */ c("$ZodBase64URL", (e, n) => {
  n.pattern ?? (n.pattern = Sn), k.init(e, n), e._zod.onattach.push((t) => {
    t._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (t) => {
    Fo(t.value) || t.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: t.value,
      inst: e,
      continue: !n.abort
    });
  };
}), Vo = /* @__PURE__ */ c("$ZodE164", (e, n) => {
  n.pattern ?? (n.pattern = Xt), k.init(e, n);
});
function Wo(e, n = null) {
  try {
    const t = e.split(".");
    if (t.length !== 3)
      return !1;
    const [o] = t;
    if (!o)
      return !1;
    const r = JSON.parse(atob(o));
    return !("typ" in r && (r == null ? void 0 : r.typ) !== "JWT" || !r.alg || n && (!("alg" in r) || r.alg !== n));
  } catch {
    return !1;
  }
}
const Bo = /* @__PURE__ */ c("$ZodJWT", (e, n) => {
  k.init(e, n), e._zod.check = (t) => {
    Wo(t.value, n.alg) || t.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: t.value,
      inst: e,
      continue: !n.abort
    });
  };
}), An = /* @__PURE__ */ c("$ZodNumber", (e, n) => {
  b.init(e, n), e._zod.pattern = e._zod.bag.pattern ?? oo, e._zod.parse = (t, o) => {
    if (n.coerce)
      try {
        t.value = Number(t.value);
      } catch {
      }
    const r = t.value;
    if (typeof r == "number" && !Number.isNaN(r) && Number.isFinite(r))
      return t;
    const s = typeof r == "number" ? Number.isNaN(r) ? "NaN" : Number.isFinite(r) ? void 0 : "Infinity" : void 0;
    return t.issues.push({
      expected: "number",
      code: "invalid_type",
      input: r,
      inst: e,
      ...s ? { received: s } : {}
    }), t;
  };
}), qo = /* @__PURE__ */ c("$ZodNumber", (e, n) => {
  co.init(e, n), An.init(e, n);
}), Jo = /* @__PURE__ */ c("$ZodBoolean", (e, n) => {
  b.init(e, n), e._zod.pattern = ro, e._zod.parse = (t, o) => {
    if (n.coerce)
      try {
        t.value = !!t.value;
      } catch {
      }
    const r = t.value;
    return typeof r == "boolean" || t.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: r,
      inst: e
    }), t;
  };
}), Ho = /* @__PURE__ */ c("$ZodNull", (e, n) => {
  b.init(e, n), e._zod.pattern = io, e._zod.values = /* @__PURE__ */ new Set([null]), e._zod.parse = (t, o) => {
    const r = t.value;
    return r === null || t.issues.push({
      expected: "null",
      code: "invalid_type",
      input: r,
      inst: e
    }), t;
  };
}), Xo = /* @__PURE__ */ c("$ZodUnknown", (e, n) => {
  b.init(e, n), e._zod.parse = (t) => t;
}), Yo = /* @__PURE__ */ c("$ZodNever", (e, n) => {
  b.init(e, n), e._zod.parse = (t, o) => (t.issues.push({
    expected: "never",
    code: "invalid_type",
    input: t.value,
    inst: e
  }), t);
});
function Fe(e, n, t) {
  e.issues.length && n.issues.push(...B(t, e.issues)), n.value[t] = e.value;
}
const Qo = /* @__PURE__ */ c("$ZodArray", (e, n) => {
  b.init(e, n), e._zod.parse = (t, o) => {
    const r = t.value;
    if (!Array.isArray(r))
      return t.issues.push({
        expected: "array",
        code: "invalid_type",
        input: r,
        inst: e
      }), t;
    t.value = Array(r.length);
    const s = [];
    for (let a = 0; a < r.length; a++) {
      const u = r[a], l = n.element._zod.run({
        value: u,
        issues: []
      }, o);
      l instanceof Promise ? s.push(l.then((f) => Fe(f, t, a))) : Fe(l, t, a);
    }
    return s.length ? Promise.all(s).then(() => t) : t;
  };
});
function le(e, n, t, o) {
  e.issues.length && n.issues.push(...B(t, e.issues)), e.value === void 0 ? t in o && (n.value[t] = void 0) : n.value[t] = e.value;
}
function In(e) {
  var o, r, s, a;
  const n = Object.keys(e.shape);
  for (const u of n)
    if (!((a = (s = (r = (o = e.shape) == null ? void 0 : o[u]) == null ? void 0 : r._zod) == null ? void 0 : s.traits) != null && a.has("$ZodType")))
      throw new Error(`Invalid element at key "${u}": expected a Zod schema`);
  const t = ht(e.shape);
  return {
    ...e,
    keys: n,
    keySet: new Set(n),
    numKeys: n.length,
    optionalKeys: new Set(t)
  };
}
function Zn(e, n, t, o, r, s) {
  const a = [], u = r.keySet, l = r.catchall._zod, f = l.def.type;
  for (const v of Object.keys(n)) {
    if (u.has(v))
      continue;
    if (f === "never") {
      a.push(v);
      continue;
    }
    const E = l.run({ value: n[v], issues: [] }, o);
    E instanceof Promise ? e.push(E.then((z) => le(z, t, v, n))) : le(E, t, v, n);
  }
  return a.length && t.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: n,
    inst: s
  }), e.length ? Promise.all(e).then(() => t) : t;
}
const er = /* @__PURE__ */ c("$ZodObject", (e, n) => {
  b.init(e, n);
  const t = Object.getOwnPropertyDescriptor(n, "shape");
  if (!(t != null && t.get)) {
    const u = n.shape;
    Object.defineProperty(n, "shape", {
      get: () => {
        const l = { ...u };
        return Object.defineProperty(n, "shape", {
          value: l
        }), l;
      }
    });
  }
  const o = fe(() => In(n));
  S(e._zod, "propValues", () => {
    const u = n.shape, l = {};
    for (const f in u) {
      const v = u[f]._zod;
      if (v.values) {
        l[f] ?? (l[f] = /* @__PURE__ */ new Set());
        for (const E of v.values)
          l[f].add(E);
      }
    }
    return l;
  });
  const r = ne, s = n.catchall;
  let a;
  e._zod.parse = (u, l) => {
    a ?? (a = o.value);
    const f = u.value;
    if (!r(f))
      return u.issues.push({
        expected: "object",
        code: "invalid_type",
        input: f,
        inst: e
      }), u;
    u.value = {};
    const v = [], E = a.shape;
    for (const z of a.keys) {
      const Z = E[z]._zod.run({ value: f[z], issues: [] }, l);
      Z instanceof Promise ? v.push(Z.then((V) => le(V, u, z, f))) : le(Z, u, z, f);
    }
    return s ? Zn(v, f, u, l, o.value, e) : v.length ? Promise.all(v).then(() => u) : u;
  };
}), nr = /* @__PURE__ */ c("$ZodObjectJIT", (e, n) => {
  er.init(e, n);
  const t = e._zod.parse, o = fe(() => In(n)), r = (z) => {
    const A = new ko(["shape", "payload", "ctx"]), Z = o.value, V = (P) => {
      const D = Me(P);
      return `shape[${D}]._zod.run({ value: input[${D}], issues: [] }, ctx)`;
    };
    A.write("const input = payload.value;");
    const Le = /* @__PURE__ */ Object.create(null);
    let et = 0;
    for (const P of Z.keys)
      Le[P] = `key_${et++}`;
    A.write("const newResult = {};");
    for (const P of Z.keys) {
      const D = Le[P], Y = Me(P);
      A.write(`const ${D} = ${V(P)};`), A.write(`
        if (${D}.issues.length) {
          payload.issues = payload.issues.concat(${D}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${Y}, ...iss.path] : [${Y}]
          })));
        }
        
        
        if (${D}.value === undefined) {
          if (${Y} in input) {
            newResult[${Y}] = undefined;
          }
        } else {
          newResult[${Y}] = ${D}.value;
        }
        
      `);
    }
    A.write("payload.value = newResult;"), A.write("return payload;");
    const nt = A.compile();
    return (P, D) => nt(z, P, D);
  };
  let s;
  const a = ne, u = !hn.jitless, f = u && dt.value, v = n.catchall;
  let E;
  e._zod.parse = (z, A) => {
    E ?? (E = o.value);
    const Z = z.value;
    return a(Z) ? u && f && (A == null ? void 0 : A.async) === !1 && A.jitless !== !0 ? (s || (s = r(n.shape)), z = s(z, A), v ? Zn([], Z, z, A, E, e) : z) : t(z, A) : (z.issues.push({
      expected: "object",
      code: "invalid_type",
      input: Z,
      inst: e
    }), z);
  };
});
function Ge(e, n, t, o) {
  for (const s of e)
    if (s.issues.length === 0)
      return n.value = s.value, n;
  const r = e.filter((s) => !W(s));
  return r.length === 1 ? (n.value = r[0].value, r[0]) : (n.issues.push({
    code: "invalid_union",
    input: n.value,
    inst: t,
    errors: e.map((s) => s.issues.map((a) => j(a, o, L())))
  }), n);
}
const Rn = /* @__PURE__ */ c("$ZodUnion", (e, n) => {
  b.init(e, n), S(e._zod, "optin", () => n.options.some((r) => r._zod.optin === "optional") ? "optional" : void 0), S(e._zod, "optout", () => n.options.some((r) => r._zod.optout === "optional") ? "optional" : void 0), S(e._zod, "values", () => {
    if (n.options.every((r) => r._zod.values))
      return new Set(n.options.flatMap((r) => Array.from(r._zod.values)));
  }), S(e._zod, "pattern", () => {
    if (n.options.every((r) => r._zod.pattern)) {
      const r = n.options.map((s) => s._zod.pattern);
      return new RegExp(`^(${r.map((s) => $e(s.source)).join("|")})$`);
    }
  });
  const t = n.options.length === 1, o = n.options[0]._zod.run;
  e._zod.parse = (r, s) => {
    if (t)
      return o(r, s);
    let a = !1;
    const u = [];
    for (const l of n.options) {
      const f = l._zod.run({
        value: r.value,
        issues: []
      }, s);
      if (f instanceof Promise)
        u.push(f), a = !0;
      else {
        if (f.issues.length === 0)
          return f;
        u.push(f);
      }
    }
    return a ? Promise.all(u).then((l) => Ge(l, r, e, s)) : Ge(u, r, e, s);
  };
}), tr = /* @__PURE__ */ c("$ZodDiscriminatedUnion", (e, n) => {
  Rn.init(e, n);
  const t = e._zod.parse;
  S(e._zod, "propValues", () => {
    const r = {};
    for (const s of n.options) {
      const a = s._zod.propValues;
      if (!a || Object.keys(a).length === 0)
        throw new Error(`Invalid discriminated union option at index "${n.options.indexOf(s)}"`);
      for (const [u, l] of Object.entries(a)) {
        r[u] || (r[u] = /* @__PURE__ */ new Set());
        for (const f of l)
          r[u].add(f);
      }
    }
    return r;
  });
  const o = fe(() => {
    var a;
    const r = n.options, s = /* @__PURE__ */ new Map();
    for (const u of r) {
      const l = (a = u._zod.propValues) == null ? void 0 : a[n.discriminator];
      if (!l || l.size === 0)
        throw new Error(`Invalid discriminated union option at index "${n.options.indexOf(u)}"`);
      for (const f of l) {
        if (s.has(f))
          throw new Error(`Duplicate discriminator value "${String(f)}"`);
        s.set(f, u);
      }
    }
    return s;
  });
  e._zod.parse = (r, s) => {
    const a = r.value;
    if (!ne(a))
      return r.issues.push({
        code: "invalid_type",
        expected: "object",
        input: a,
        inst: e
      }), r;
    const u = o.value.get(a == null ? void 0 : a[n.discriminator]);
    return u ? u._zod.run(r, s) : n.unionFallback ? t(r, s) : (r.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: n.discriminator,
      input: a,
      path: [n.discriminator],
      inst: e
    }), r);
  };
}), or = /* @__PURE__ */ c("$ZodIntersection", (e, n) => {
  b.init(e, n), e._zod.parse = (t, o) => {
    const r = t.value, s = n.left._zod.run({ value: r, issues: [] }, o), a = n.right._zod.run({ value: r, issues: [] }, o);
    return s instanceof Promise || a instanceof Promise ? Promise.all([s, a]).then(([l, f]) => Ve(t, l, f)) : Ve(t, s, a);
  };
});
function ze(e, n) {
  if (e === n)
    return { valid: !0, data: e };
  if (e instanceof Date && n instanceof Date && +e == +n)
    return { valid: !0, data: e };
  if (J(e) && J(n)) {
    const t = Object.keys(n), o = Object.keys(e).filter((s) => t.indexOf(s) !== -1), r = { ...e, ...n };
    for (const s of o) {
      const a = ze(e[s], n[s]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [s, ...a.mergeErrorPath]
        };
      r[s] = a.data;
    }
    return { valid: !0, data: r };
  }
  if (Array.isArray(e) && Array.isArray(n)) {
    if (e.length !== n.length)
      return { valid: !1, mergeErrorPath: [] };
    const t = [];
    for (let o = 0; o < e.length; o++) {
      const r = e[o], s = n[o], a = ze(r, s);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      t.push(a.data);
    }
    return { valid: !0, data: t };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Ve(e, n, t) {
  if (n.issues.length && e.issues.push(...n.issues), t.issues.length && e.issues.push(...t.issues), W(e))
    return e;
  const o = ze(n.value, t.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const rr = /* @__PURE__ */ c("$ZodRecord", (e, n) => {
  b.init(e, n), e._zod.parse = (t, o) => {
    const r = t.value;
    if (!J(r))
      return t.issues.push({
        expected: "record",
        code: "invalid_type",
        input: r,
        inst: e
      }), t;
    const s = [];
    if (n.keyType._zod.values) {
      const a = n.keyType._zod.values;
      t.value = {};
      for (const l of a)
        if (typeof l == "string" || typeof l == "number" || typeof l == "symbol") {
          const f = n.valueType._zod.run({ value: r[l], issues: [] }, o);
          f instanceof Promise ? s.push(f.then((v) => {
            v.issues.length && t.issues.push(...B(l, v.issues)), t.value[l] = v.value;
          })) : (f.issues.length && t.issues.push(...B(l, f.issues)), t.value[l] = f.value);
        }
      let u;
      for (const l in r)
        a.has(l) || (u = u ?? [], u.push(l));
      u && u.length > 0 && t.issues.push({
        code: "unrecognized_keys",
        input: r,
        inst: e,
        keys: u
      });
    } else {
      t.value = {};
      for (const a of Reflect.ownKeys(r)) {
        if (a === "__proto__")
          continue;
        const u = n.keyType._zod.run({ value: a, issues: [] }, o);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (u.issues.length) {
          t.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((f) => j(f, o, L())),
            input: a,
            path: [a],
            inst: e
          }), t.value[u.value] = u.value;
          continue;
        }
        const l = n.valueType._zod.run({ value: r[a], issues: [] }, o);
        l instanceof Promise ? s.push(l.then((f) => {
          f.issues.length && t.issues.push(...B(a, f.issues)), t.value[u.value] = f.value;
        })) : (l.issues.length && t.issues.push(...B(a, l.issues)), t.value[u.value] = l.value);
      }
    }
    return s.length ? Promise.all(s).then(() => t) : t;
  };
}), ir = /* @__PURE__ */ c("$ZodEnum", (e, n) => {
  b.init(e, n);
  const t = ct(n.entries), o = new Set(t);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${t.filter((r) => mt.has(typeof r)).map((r) => typeof r == "string" ? H(r) : r.toString()).join("|")})$`), e._zod.parse = (r, s) => {
    const a = r.value;
    return o.has(a) || r.issues.push({
      code: "invalid_value",
      values: t,
      input: a,
      inst: e
    }), r;
  };
}), sr = /* @__PURE__ */ c("$ZodLiteral", (e, n) => {
  if (b.init(e, n), n.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  e._zod.values = new Set(n.values), e._zod.pattern = new RegExp(`^(${n.values.map((t) => typeof t == "string" ? H(t) : t ? H(t.toString()) : String(t)).join("|")})$`), e._zod.parse = (t, o) => {
    const r = t.value;
    return e._zod.values.has(r) || t.issues.push({
      code: "invalid_value",
      values: n.values,
      input: r,
      inst: e
    }), t;
  };
}), ar = /* @__PURE__ */ c("$ZodTransform", (e, n) => {
  b.init(e, n), e._zod.parse = (t, o) => {
    if (o.direction === "backward")
      throw new mn(e.constructor.name);
    const r = n.transform(t.value, t);
    if (o.async)
      return (r instanceof Promise ? r : Promise.resolve(r)).then((a) => (t.value = a, t));
    if (r instanceof Promise)
      throw new q();
    return t.value = r, t;
  };
});
function We(e, n) {
  return e.issues.length && n === void 0 ? { issues: [], value: void 0 } : e;
}
const ur = /* @__PURE__ */ c("$ZodOptional", (e, n) => {
  b.init(e, n), e._zod.optin = "optional", e._zod.optout = "optional", S(e._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, void 0]) : void 0), S(e._zod, "pattern", () => {
    const t = n.innerType._zod.pattern;
    return t ? new RegExp(`^(${$e(t.source)})?$`) : void 0;
  }), e._zod.parse = (t, o) => {
    if (n.innerType._zod.optin === "optional") {
      const r = n.innerType._zod.run(t, o);
      return r instanceof Promise ? r.then((s) => We(s, t.value)) : We(r, t.value);
    }
    return t.value === void 0 ? t : n.innerType._zod.run(t, o);
  };
}), cr = /* @__PURE__ */ c("$ZodNullable", (e, n) => {
  b.init(e, n), S(e._zod, "optin", () => n.innerType._zod.optin), S(e._zod, "optout", () => n.innerType._zod.optout), S(e._zod, "pattern", () => {
    const t = n.innerType._zod.pattern;
    return t ? new RegExp(`^(${$e(t.source)}|null)$`) : void 0;
  }), S(e._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, null]) : void 0), e._zod.parse = (t, o) => t.value === null ? t : n.innerType._zod.run(t, o);
}), lr = /* @__PURE__ */ c("$ZodDefault", (e, n) => {
  b.init(e, n), e._zod.optin = "optional", S(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (t, o) => {
    if (o.direction === "backward")
      return n.innerType._zod.run(t, o);
    if (t.value === void 0)
      return t.value = n.defaultValue, t;
    const r = n.innerType._zod.run(t, o);
    return r instanceof Promise ? r.then((s) => Be(s, n)) : Be(r, n);
  };
});
function Be(e, n) {
  return e.value === void 0 && (e.value = n.defaultValue), e;
}
const dr = /* @__PURE__ */ c("$ZodPrefault", (e, n) => {
  b.init(e, n), e._zod.optin = "optional", S(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (t, o) => (o.direction === "backward" || t.value === void 0 && (t.value = n.defaultValue), n.innerType._zod.run(t, o));
}), mr = /* @__PURE__ */ c("$ZodNonOptional", (e, n) => {
  b.init(e, n), S(e._zod, "values", () => {
    const t = n.innerType._zod.values;
    return t ? new Set([...t].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (t, o) => {
    const r = n.innerType._zod.run(t, o);
    return r instanceof Promise ? r.then((s) => qe(s, e)) : qe(r, e);
  };
});
function qe(e, n) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: n
  }), e;
}
const hr = /* @__PURE__ */ c("$ZodCatch", (e, n) => {
  b.init(e, n), S(e._zod, "optin", () => n.innerType._zod.optin), S(e._zod, "optout", () => n.innerType._zod.optout), S(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (t, o) => {
    if (o.direction === "backward")
      return n.innerType._zod.run(t, o);
    const r = n.innerType._zod.run(t, o);
    return r instanceof Promise ? r.then((s) => (t.value = s.value, s.issues.length && (t.value = n.catchValue({
      ...t,
      error: {
        issues: s.issues.map((a) => j(a, o, L()))
      },
      input: t.value
    }), t.issues = []), t)) : (t.value = r.value, r.issues.length && (t.value = n.catchValue({
      ...t,
      error: {
        issues: r.issues.map((s) => j(s, o, L()))
      },
      input: t.value
    }), t.issues = []), t);
  };
}), fr = /* @__PURE__ */ c("$ZodPipe", (e, n) => {
  b.init(e, n), S(e._zod, "values", () => n.in._zod.values), S(e._zod, "optin", () => n.in._zod.optin), S(e._zod, "optout", () => n.out._zod.optout), S(e._zod, "propValues", () => n.in._zod.propValues), e._zod.parse = (t, o) => {
    if (o.direction === "backward") {
      const s = n.out._zod.run(t, o);
      return s instanceof Promise ? s.then((a) => se(a, n.in, o)) : se(s, n.in, o);
    }
    const r = n.in._zod.run(t, o);
    return r instanceof Promise ? r.then((s) => se(s, n.out, o)) : se(r, n.out, o);
  };
});
function se(e, n, t) {
  return e.issues.length ? (e.aborted = !0, e) : n._zod.run({ value: e.value, issues: e.issues }, t);
}
const pr = /* @__PURE__ */ c("$ZodReadonly", (e, n) => {
  b.init(e, n), S(e._zod, "propValues", () => n.innerType._zod.propValues), S(e._zod, "values", () => n.innerType._zod.values), S(e._zod, "optin", () => n.innerType._zod.optin), S(e._zod, "optout", () => n.innerType._zod.optout), e._zod.parse = (t, o) => {
    if (o.direction === "backward")
      return n.innerType._zod.run(t, o);
    const r = n.innerType._zod.run(t, o);
    return r instanceof Promise ? r.then(Je) : Je(r);
  };
});
function Je(e) {
  return e.value = Object.freeze(e.value), e;
}
const _r = /* @__PURE__ */ c("$ZodCustom", (e, n) => {
  R.init(e, n), b.init(e, n), e._zod.parse = (t, o) => t, e._zod.check = (t) => {
    const o = t.value, r = n.fn(o);
    if (r instanceof Promise)
      return r.then((s) => He(s, t, o, e));
    He(r, t, o, e);
  };
});
function He(e, n, t, o) {
  if (!e) {
    const r = {
      code: "custom",
      input: t,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (r.params = o._zod.def.params), n.issues.push(te(r));
  }
}
class gr {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(n, ...t) {
    const o = t[0];
    if (this._map.set(n, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, n);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(n) {
    const t = this._map.get(n);
    return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(n), this;
  }
  get(n) {
    const t = n._zod.parent;
    if (t) {
      const o = { ...this.get(t) ?? {} };
      delete o.id;
      const r = { ...o, ...this._map.get(n) };
      return Object.keys(r).length ? r : void 0;
    }
    return this._map.get(n);
  }
  has(n) {
    return this._map.has(n);
  }
}
function vr() {
  return new gr();
}
const ae = /* @__PURE__ */ vr();
function Sr(e, n) {
  return new e({
    type: "string",
    ...p(n)
  });
}
function br(e, n) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Xe(e, n) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function $n(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function kr(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...p(n)
  });
}
function wr(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...p(n)
  });
}
function yr(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...p(n)
  });
}
function Er(e, n) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function zr(e, n) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Ar(e, n) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Ir(e, n) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Zr(e, n) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Rr(e, n) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function $r(e, n) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Tr(e, n) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Cr(e, n) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Nr(e, n) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Dr(e, n) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Pr(e, n) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Or(e, n) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function xr(e, n) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Ur(e, n) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function Lr(e, n) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...p(n)
  });
}
function jr(e, n) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...p(n)
  });
}
function Mr(e, n) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...p(n)
  });
}
function Kr(e, n) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...p(n)
  });
}
function Fr(e, n) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...p(n)
  });
}
function Gr(e, n) {
  return new e({
    type: "number",
    checks: [],
    ...p(n)
  });
}
function Vr(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...p(n)
  });
}
function Wr(e, n) {
  return new e({
    type: "boolean",
    ...p(n)
  });
}
function Br(e, n) {
  return new e({
    type: "null",
    ...p(n)
  });
}
function qr(e) {
  return new e({
    type: "unknown"
  });
}
function Jr(e, n) {
  return new e({
    type: "never",
    ...p(n)
  });
}
function Ye(e, n) {
  return new yn({
    check: "less_than",
    ...p(n),
    value: e,
    inclusive: !1
  });
}
function ve(e, n) {
  return new yn({
    check: "less_than",
    ...p(n),
    value: e,
    inclusive: !0
  });
}
function Qe(e, n) {
  return new En({
    check: "greater_than",
    ...p(n),
    value: e,
    inclusive: !1
  });
}
function Se(e, n) {
  return new En({
    check: "greater_than",
    ...p(n),
    value: e,
    inclusive: !0
  });
}
function en(e, n) {
  return new uo({
    check: "multiple_of",
    ...p(n),
    value: e
  });
}
function Tn(e, n) {
  return new lo({
    check: "max_length",
    ...p(n),
    maximum: e
  });
}
function de(e, n) {
  return new mo({
    check: "min_length",
    ...p(n),
    minimum: e
  });
}
function Cn(e, n) {
  return new ho({
    check: "length_equals",
    ...p(n),
    length: e
  });
}
function Hr(e, n) {
  return new fo({
    check: "string_format",
    format: "regex",
    ...p(n),
    pattern: e
  });
}
function Xr(e) {
  return new po({
    check: "string_format",
    format: "lowercase",
    ...p(e)
  });
}
function Yr(e) {
  return new _o({
    check: "string_format",
    format: "uppercase",
    ...p(e)
  });
}
function Qr(e, n) {
  return new go({
    check: "string_format",
    format: "includes",
    ...p(n),
    includes: e
  });
}
function ei(e, n) {
  return new vo({
    check: "string_format",
    format: "starts_with",
    ...p(n),
    prefix: e
  });
}
function ni(e, n) {
  return new So({
    check: "string_format",
    format: "ends_with",
    ...p(n),
    suffix: e
  });
}
function oe(e) {
  return new bo({
    check: "overwrite",
    tx: e
  });
}
function ti(e) {
  return oe((n) => n.normalize(e));
}
function oi() {
  return oe((e) => e.trim());
}
function ri() {
  return oe((e) => e.toLowerCase());
}
function ii() {
  return oe((e) => e.toUpperCase());
}
function si(e, n, t) {
  return new e({
    type: "array",
    element: n,
    // get element() {
    //   return element;
    // },
    ...p(t)
  });
}
function ai(e, n, t) {
  return new e({
    type: "custom",
    check: "custom",
    fn: n,
    ...p(t)
  });
}
function ui(e) {
  const n = ci((t) => (t.addIssue = (o) => {
    if (typeof o == "string")
      t.issues.push(te(o, t.value, n._zod.def));
    else {
      const r = o;
      r.fatal && (r.continue = !1), r.code ?? (r.code = "custom"), r.input ?? (r.input = t.value), r.inst ?? (r.inst = n), r.continue ?? (r.continue = !n._zod.def.abort), t.issues.push(te(r));
    }
  }, e(t.value, t)));
  return n;
}
function ci(e, n) {
  const t = new R({
    check: "custom",
    ...p(n)
  });
  return t._zod.check = e, t;
}
const li = /* @__PURE__ */ c("ZodISODateTime", (e, n) => {
  Do.init(e, n), y.init(e, n);
});
function me(e) {
  return jr(li, e);
}
const di = /* @__PURE__ */ c("ZodISODate", (e, n) => {
  Po.init(e, n), y.init(e, n);
});
function mi(e) {
  return Mr(di, e);
}
const hi = /* @__PURE__ */ c("ZodISOTime", (e, n) => {
  Oo.init(e, n), y.init(e, n);
});
function fi(e) {
  return Kr(hi, e);
}
const pi = /* @__PURE__ */ c("ZodISODuration", (e, n) => {
  xo.init(e, n), y.init(e, n);
});
function _i(e) {
  return Fr(pi, e);
}
const gi = (e, n) => {
  gn.init(e, n), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (t) => yt(e, t)
      // enumerable: false,
    },
    flatten: {
      value: (t) => wt(e, t)
      // enumerable: false,
    },
    addIssue: {
      value: (t) => {
        e.issues.push(t), e.message = JSON.stringify(e.issues, Ee, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (t) => {
        e.issues.push(...t), e.message = JSON.stringify(e.issues, Ee, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, C = c("ZodError", gi, {
  Parent: Error
}), vi = /* @__PURE__ */ Ce(C), Si = /* @__PURE__ */ Ne(C), bi = /* @__PURE__ */ pe(C), ki = /* @__PURE__ */ _e(C), wi = /* @__PURE__ */ At(C), yi = /* @__PURE__ */ It(C), Ei = /* @__PURE__ */ Zt(C), zi = /* @__PURE__ */ Rt(C), Ai = /* @__PURE__ */ $t(C), Ii = /* @__PURE__ */ Tt(C), Zi = /* @__PURE__ */ Ct(C), Ri = /* @__PURE__ */ Nt(C), w = /* @__PURE__ */ c("ZodType", (e, n) => (b.init(e, n), e.def = n, e.type = n.type, Object.defineProperty(e, "_def", { value: n }), e.check = (...t) => e.clone(F(n, {
  checks: [
    ...n.checks ?? [],
    ...t.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
  ]
})), e.clone = (t, o) => U(e, t, o), e.brand = () => e, e.register = (t, o) => (t.add(e, o), e), e.parse = (t, o) => vi(e, t, o, { callee: e.parse }), e.safeParse = (t, o) => bi(e, t, o), e.parseAsync = async (t, o) => Si(e, t, o, { callee: e.parseAsync }), e.safeParseAsync = async (t, o) => ki(e, t, o), e.spa = e.safeParseAsync, e.encode = (t, o) => wi(e, t, o), e.decode = (t, o) => yi(e, t, o), e.encodeAsync = async (t, o) => Ei(e, t, o), e.decodeAsync = async (t, o) => zi(e, t, o), e.safeEncode = (t, o) => Ai(e, t, o), e.safeDecode = (t, o) => Ii(e, t, o), e.safeEncodeAsync = async (t, o) => Zi(e, t, o), e.safeDecodeAsync = async (t, o) => Ri(e, t, o), e.refine = (t, o) => e.check(ks(t, o)), e.superRefine = (t) => e.check(ws(t)), e.overwrite = (t) => e.check(oe(t)), e.optional = () => on(e), e.nullable = () => rn(e), e.nullish = () => on(rn(e)), e.nonoptional = (t) => fs(e, t), e.array = () => h(e), e.or = (t) => x([e, t]), e.and = (t) => os(e, t), e.transform = (t) => sn(e, us(t)), e.default = (t) => ds(e, t), e.prefault = (t) => hs(e, t), e.catch = (t) => _s(e, t), e.pipe = (t) => sn(e, t), e.readonly = () => Ss(e), e.describe = (t) => {
  const o = e.clone();
  return ae.add(o, { description: t }), o;
}, Object.defineProperty(e, "description", {
  get() {
    var t;
    return (t = ae.get(e)) == null ? void 0 : t.description;
  },
  configurable: !0
}), e.meta = (...t) => {
  if (t.length === 0)
    return ae.get(e);
  const o = e.clone();
  return ae.add(o, t[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Nn = /* @__PURE__ */ c("_ZodString", (e, n) => {
  De.init(e, n), w.init(e, n);
  const t = e._zod.bag;
  e.format = t.format ?? null, e.minLength = t.minimum ?? null, e.maxLength = t.maximum ?? null, e.regex = (...o) => e.check(Hr(...o)), e.includes = (...o) => e.check(Qr(...o)), e.startsWith = (...o) => e.check(ei(...o)), e.endsWith = (...o) => e.check(ni(...o)), e.min = (...o) => e.check(de(...o)), e.max = (...o) => e.check(Tn(...o)), e.length = (...o) => e.check(Cn(...o)), e.nonempty = (...o) => e.check(de(1, ...o)), e.lowercase = (o) => e.check(Xr(o)), e.uppercase = (o) => e.check(Yr(o)), e.trim = () => e.check(oi()), e.normalize = (...o) => e.check(ti(...o)), e.toLowerCase = () => e.check(ri()), e.toUpperCase = () => e.check(ii());
}), $i = /* @__PURE__ */ c("ZodString", (e, n) => {
  De.init(e, n), Nn.init(e, n), e.email = (t) => e.check(br(Ti, t)), e.url = (t) => e.check(Er(Ci, t)), e.jwt = (t) => e.check(Lr(Bi, t)), e.emoji = (t) => e.check(zr(Ni, t)), e.guid = (t) => e.check(Xe(nn, t)), e.uuid = (t) => e.check($n(ee, t)), e.uuidv4 = (t) => e.check(kr(ee, t)), e.uuidv6 = (t) => e.check(wr(ee, t)), e.uuidv7 = (t) => e.check(yr(ee, t)), e.nanoid = (t) => e.check(Ar(Di, t)), e.guid = (t) => e.check(Xe(nn, t)), e.cuid = (t) => e.check(Ir(Pi, t)), e.cuid2 = (t) => e.check(Zr(Oi, t)), e.ulid = (t) => e.check(Rr(xi, t)), e.base64 = (t) => e.check(Or(Gi, t)), e.base64url = (t) => e.check(xr(Vi, t)), e.xid = (t) => e.check($r(Ui, t)), e.ksuid = (t) => e.check(Tr(Li, t)), e.ipv4 = (t) => e.check(Cr(ji, t)), e.ipv6 = (t) => e.check(Nr(Mi, t)), e.cidrv4 = (t) => e.check(Dr(Ki, t)), e.cidrv6 = (t) => e.check(Pr(Fi, t)), e.e164 = (t) => e.check(Ur(Wi, t)), e.datetime = (t) => e.check(me(t)), e.date = (t) => e.check(mi(t)), e.time = (t) => e.check(fi(t)), e.duration = (t) => e.check(_i(t));
});
function i(e) {
  return Sr($i, e);
}
const y = /* @__PURE__ */ c("ZodStringFormat", (e, n) => {
  k.init(e, n), Nn.init(e, n);
}), Ti = /* @__PURE__ */ c("ZodEmail", (e, n) => {
  zo.init(e, n), y.init(e, n);
}), nn = /* @__PURE__ */ c("ZodGUID", (e, n) => {
  yo.init(e, n), y.init(e, n);
}), ee = /* @__PURE__ */ c("ZodUUID", (e, n) => {
  Eo.init(e, n), y.init(e, n);
});
function G(e) {
  return $n(ee, e);
}
const Ci = /* @__PURE__ */ c("ZodURL", (e, n) => {
  Ao.init(e, n), y.init(e, n);
}), Ni = /* @__PURE__ */ c("ZodEmoji", (e, n) => {
  Io.init(e, n), y.init(e, n);
}), Di = /* @__PURE__ */ c("ZodNanoID", (e, n) => {
  Zo.init(e, n), y.init(e, n);
}), Pi = /* @__PURE__ */ c("ZodCUID", (e, n) => {
  Ro.init(e, n), y.init(e, n);
}), Oi = /* @__PURE__ */ c("ZodCUID2", (e, n) => {
  $o.init(e, n), y.init(e, n);
}), xi = /* @__PURE__ */ c("ZodULID", (e, n) => {
  To.init(e, n), y.init(e, n);
}), Ui = /* @__PURE__ */ c("ZodXID", (e, n) => {
  Co.init(e, n), y.init(e, n);
}), Li = /* @__PURE__ */ c("ZodKSUID", (e, n) => {
  No.init(e, n), y.init(e, n);
}), ji = /* @__PURE__ */ c("ZodIPv4", (e, n) => {
  Uo.init(e, n), y.init(e, n);
}), Mi = /* @__PURE__ */ c("ZodIPv6", (e, n) => {
  Lo.init(e, n), y.init(e, n);
}), Ki = /* @__PURE__ */ c("ZodCIDRv4", (e, n) => {
  jo.init(e, n), y.init(e, n);
}), Fi = /* @__PURE__ */ c("ZodCIDRv6", (e, n) => {
  Mo.init(e, n), y.init(e, n);
}), Gi = /* @__PURE__ */ c("ZodBase64", (e, n) => {
  Ko.init(e, n), y.init(e, n);
}), Vi = /* @__PURE__ */ c("ZodBase64URL", (e, n) => {
  Go.init(e, n), y.init(e, n);
}), Wi = /* @__PURE__ */ c("ZodE164", (e, n) => {
  Vo.init(e, n), y.init(e, n);
}), Bi = /* @__PURE__ */ c("ZodJWT", (e, n) => {
  Bo.init(e, n), y.init(e, n);
}), Dn = /* @__PURE__ */ c("ZodNumber", (e, n) => {
  An.init(e, n), w.init(e, n), e.gt = (o, r) => e.check(Qe(o, r)), e.gte = (o, r) => e.check(Se(o, r)), e.min = (o, r) => e.check(Se(o, r)), e.lt = (o, r) => e.check(Ye(o, r)), e.lte = (o, r) => e.check(ve(o, r)), e.max = (o, r) => e.check(ve(o, r)), e.int = (o) => e.check(tn(o)), e.safe = (o) => e.check(tn(o)), e.positive = (o) => e.check(Qe(0, o)), e.nonnegative = (o) => e.check(Se(0, o)), e.negative = (o) => e.check(Ye(0, o)), e.nonpositive = (o) => e.check(ve(0, o)), e.multipleOf = (o, r) => e.check(en(o, r)), e.step = (o, r) => e.check(en(o, r)), e.finite = () => e;
  const t = e._zod.bag;
  e.minValue = Math.max(t.minimum ?? Number.NEGATIVE_INFINITY, t.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(t.maximum ?? Number.POSITIVE_INFINITY, t.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (t.format ?? "").includes("int") || Number.isSafeInteger(t.multipleOf ?? 0.5), e.isFinite = !0, e.format = t.format ?? null;
});
function m(e) {
  return Gr(Dn, e);
}
const qi = /* @__PURE__ */ c("ZodNumberFormat", (e, n) => {
  qo.init(e, n), Dn.init(e, n);
});
function tn(e) {
  return Vr(qi, e);
}
const Ji = /* @__PURE__ */ c("ZodBoolean", (e, n) => {
  Jo.init(e, n), w.init(e, n);
});
function I(e) {
  return Wr(Ji, e);
}
const Hi = /* @__PURE__ */ c("ZodNull", (e, n) => {
  Ho.init(e, n), w.init(e, n);
});
function Ae(e) {
  return Br(Hi, e);
}
const Xi = /* @__PURE__ */ c("ZodUnknown", (e, n) => {
  Xo.init(e, n), w.init(e, n);
});
function $() {
  return qr(Xi);
}
const Yi = /* @__PURE__ */ c("ZodNever", (e, n) => {
  Yo.init(e, n), w.init(e, n);
});
function Qi(e) {
  return Jr(Yi, e);
}
const es = /* @__PURE__ */ c("ZodArray", (e, n) => {
  Qo.init(e, n), w.init(e, n), e.element = n.element, e.min = (t, o) => e.check(de(t, o)), e.nonempty = (t) => e.check(de(1, t)), e.max = (t, o) => e.check(Tn(t, o)), e.length = (t, o) => e.check(Cn(t, o)), e.unwrap = () => e.element;
});
function h(e, n) {
  return si(es, e, n);
}
const Pn = /* @__PURE__ */ c("ZodObject", (e, n) => {
  nr.init(e, n), w.init(e, n), S(e, "shape", () => n.shape), e.keyof = () => _(Object.keys(e._zod.def.shape)), e.catchall = (t) => e.clone({ ...e._zod.def, catchall: t }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: $() }), e.loose = () => e.clone({ ...e._zod.def, catchall: $() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Qi() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (t) => gt(e, t), e.safeExtend = (t) => vt(e, t), e.merge = (t) => St(e, t), e.pick = (t) => pt(e, t), e.omit = (t) => _t(e, t), e.partial = (...t) => bt(Un, e, t[0]), e.required = (...t) => kt(Ln, e, t[0]);
});
function d(e, n) {
  const t = {
    type: "object",
    shape: e ?? {},
    ...p(n)
  };
  return new Pn(t);
}
function M(e, n) {
  return new Pn({
    type: "object",
    shape: e,
    catchall: $(),
    ...p(n)
  });
}
const On = /* @__PURE__ */ c("ZodUnion", (e, n) => {
  Rn.init(e, n), w.init(e, n), e.options = n.options;
});
function x(e, n) {
  return new On({
    type: "union",
    options: e,
    ...p(n)
  });
}
const ns = /* @__PURE__ */ c("ZodDiscriminatedUnion", (e, n) => {
  On.init(e, n), tr.init(e, n);
});
function X(e, n, t) {
  return new ns({
    type: "union",
    options: n,
    discriminator: e,
    ...p(t)
  });
}
const ts = /* @__PURE__ */ c("ZodIntersection", (e, n) => {
  or.init(e, n), w.init(e, n);
});
function os(e, n) {
  return new ts({
    type: "intersection",
    left: e,
    right: n
  });
}
const xn = /* @__PURE__ */ c("ZodRecord", (e, n) => {
  rr.init(e, n), w.init(e, n), e.keyType = n.keyType, e.valueType = n.valueType;
});
function T(e, n, t) {
  return new xn({
    type: "record",
    keyType: e,
    valueType: n,
    ...p(t)
  });
}
function rs(e, n, t) {
  const o = U(e);
  return o._zod.values = void 0, new xn({
    type: "record",
    keyType: o,
    valueType: n,
    ...p(t)
  });
}
const he = /* @__PURE__ */ c("ZodEnum", (e, n) => {
  ir.init(e, n), w.init(e, n), e.enum = n.entries, e.options = Object.values(n.entries);
  const t = new Set(Object.keys(n.entries));
  e.extract = (o, r) => {
    const s = {};
    for (const a of o)
      if (t.has(a))
        s[a] = n.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new he({
      ...n,
      checks: [],
      ...p(r),
      entries: s
    });
  }, e.exclude = (o, r) => {
    const s = { ...n.entries };
    for (const a of o)
      if (t.has(a))
        delete s[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new he({
      ...n,
      checks: [],
      ...p(r),
      entries: s
    });
  };
});
function _(e, n) {
  const t = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new he({
    type: "enum",
    entries: t,
    ...p(n)
  });
}
function is(e, n) {
  return new he({
    type: "enum",
    entries: e,
    ...p(n)
  });
}
const ss = /* @__PURE__ */ c("ZodLiteral", (e, n) => {
  sr.init(e, n), w.init(e, n), e.values = new Set(n.values), Object.defineProperty(e, "value", {
    get() {
      if (n.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return n.values[0];
    }
  });
});
function g(e, n) {
  return new ss({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...p(n)
  });
}
const as = /* @__PURE__ */ c("ZodTransform", (e, n) => {
  ar.init(e, n), w.init(e, n), e._zod.parse = (t, o) => {
    if (o.direction === "backward")
      throw new mn(e.constructor.name);
    t.addIssue = (s) => {
      if (typeof s == "string")
        t.issues.push(te(s, t.value, n));
      else {
        const a = s;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = t.value), a.inst ?? (a.inst = e), t.issues.push(te(a));
      }
    };
    const r = n.transform(t.value, t);
    return r instanceof Promise ? r.then((s) => (t.value = s, t)) : (t.value = r, t);
  };
});
function us(e) {
  return new as({
    type: "transform",
    transform: e
  });
}
const Un = /* @__PURE__ */ c("ZodOptional", (e, n) => {
  ur.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function on(e) {
  return new Un({
    type: "optional",
    innerType: e
  });
}
const cs = /* @__PURE__ */ c("ZodNullable", (e, n) => {
  cr.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function rn(e) {
  return new cs({
    type: "nullable",
    innerType: e
  });
}
const ls = /* @__PURE__ */ c("ZodDefault", (e, n) => {
  lr.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function ds(e, n) {
  return new ls({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof n == "function" ? n() : pn(n);
    }
  });
}
const ms = /* @__PURE__ */ c("ZodPrefault", (e, n) => {
  dr.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function hs(e, n) {
  return new ms({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof n == "function" ? n() : pn(n);
    }
  });
}
const Ln = /* @__PURE__ */ c("ZodNonOptional", (e, n) => {
  mr.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function fs(e, n) {
  return new Ln({
    type: "nonoptional",
    innerType: e,
    ...p(n)
  });
}
const ps = /* @__PURE__ */ c("ZodCatch", (e, n) => {
  hr.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function _s(e, n) {
  return new ps({
    type: "catch",
    innerType: e,
    catchValue: typeof n == "function" ? n : () => n
  });
}
const gs = /* @__PURE__ */ c("ZodPipe", (e, n) => {
  fr.init(e, n), w.init(e, n), e.in = n.in, e.out = n.out;
});
function sn(e, n) {
  return new gs({
    type: "pipe",
    in: e,
    out: n
    // ...util.normalizeParams(params),
  });
}
const vs = /* @__PURE__ */ c("ZodReadonly", (e, n) => {
  pr.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Ss(e) {
  return new vs({
    type: "readonly",
    innerType: e
  });
}
const bs = /* @__PURE__ */ c("ZodCustom", (e, n) => {
  _r.init(e, n), w.init(e, n);
});
function ks(e, n = {}) {
  return ai(bs, e, n);
}
function ws(e) {
  return ui(e);
}
const jn = {
  assessment_id: i().min(1),
  /**
   * Monotonic per run, assigned by the emitter.
   *
   * Grading fans documents out across a thread pool, so events for different
   * documents genuinely interleave and can arrive reordered. Remediation posts
   * from a single worker thread, which keeps *emission* ordered but says nothing
   * about arrival. `seq` is what lets the timeline render in the order things
   * happened, and what makes a Job replay idempotent.
   */
  seq: m().int().nonnegative(),
  occurred_at: i().min(1),
  metadata: M({ correlationId: G().optional() }).optional()
}, ys = M({
  documentsTotal: m().int().nonnegative().optional(),
  /**
   * Expected-but-absent standard documents, computed by intake
   * (`IntakeResult.missing_documents`).
   *
   * Carried because the UI must state it: a missing document counts as 0.0 in
   * the weighted domain score (`MaturityScorer.calculate_domain_score`), so a
   * user reading only the per-document figures on screen would infer a far
   * better final maturity than the report will state.
   */
  notSupplied: m().int().nonnegative().optional()
}), Es = d({
  kind: g("stage_progress"),
  ...jn,
  stage_key: _(be),
  state: _(ot),
  detail: ys.optional()
}), zs = M({
  /** state=grading. A counter tick, not a timeline entry. */
  sectionsGraded: m().int().nonnegative().optional(),
  sectionsTotal: m().int().nonnegative().optional(),
  /**
   * state=graded. The two integers everything on screen derives from: the
   * document table shows `questionsTotal - questionsMet` gaps, the timeline
   * reads "34 of 40 requirements met". Both come from the same pair, already
   * counted inside `DocumentGrader.grade`.
   *
   * Never sent before every section of the document is complete. Mid-document
   * the ratio is computed over the sections that exist at that moment
   * (`MaturityScorer.calculate_document_score`), so a document at 6 of 9
   * sections has a real, plausible, wrong number attached to it.
   */
  questionsMet: m().int().nonnegative().optional(),
  questionsTotal: m().int().nonnegative().optional(),
  /**
   * state=graded, and the reason a figure can be shown at all without lying.
   *
   * True when one or more questions never got a real answer from either the
   * section grader or the full-document fallback and were scored via an
   * `answer=0` placeholder. The figure is then a confident LOWER BOUND, which
   * the UI renders distinctly from a document cleanly graded to the same number.
   */
  partiallyGraded: I().optional(),
  unresolvedQuestionCount: m().int().nonnegative().optional(),
  /** state=classified. */
  matchedDocumentKey: i().optional(),
  confidence: i().optional(),
  /** state=failed. A bucket — never a raw error string. */
  failureReason: _(tt).optional()
}), As = d({
  kind: g("document_progress"),
  ...jn,
  /**
   * The Document ENTITY id, not the `assessment_domain_documents` join-row id —
   * the pipeline reads `documentId` off the dispatched payload
   * (`assessment/adapters/input_adapter.py`) and carries that through as its
   * internal `doc_id`. The receiver resolves it to a join row through
   * `assessment_domains` for this assessment.
   */
  document_id: i().min(1),
  state: _(rt),
  detail: zs.optional()
}), Au = X("kind", [
  Es,
  As
]), Is = ["stage_progress", "document_progress"], Zs = "result";
function Iu(e) {
  return e == null || e === "" || e === Zs ? "result" : typeof e == "string" && Is.includes(e) ? "progress" : "drop";
}
const Rs = d({
  done: m().min(0).max(1),
  inFlight: m().min(0).max(1),
  /** Counts the caption renders, e.g. "4 of 17 · 3 in flight". */
  counted: m().int().nonnegative().optional(),
  inFlightCount: m().int().nonnegative().optional(),
  total: m().int().nonnegative().optional(),
  startedAt: i().nullish(),
  completedAt: i().nullish(),
  failed: I().optional()
}), $s = d({
  queued: m().int().nonnegative(),
  reading: m().int().nonnegative(),
  read: m().int().nonnegative(),
  grading: m().int().nonnegative(),
  assessed: m().int().nonnegative(),
  failed: m().int().nonnegative(),
  notSupplied: m().int().nonnegative()
}), Zu = d({
  /** Which stage the run is in, or null once every stage has settled. */
  currentStageKey: _(be).nullable(),
  // partialRecord, not record: zod 4's `record` requires every enum key to be
  // present, and a run only has entries for the stages it has reached.
  stages: rs(_(be), Rs),
  counters: $s,
  documentsTotal: m().int().nonnegative(),
  /**
   * When we last heard anything. The UI derives "stalled" from this rather than
   * receiving it, because silence cannot be reported by the thing that has gone
   * silent.
   */
  lastEventAt: i(),
  firstEventAt: i(),
  /** Highest `seq` applied, so a reordered late arrival can be recognised. */
  lastSeq: m().int().nonnegative()
});
function Ru(e = 0) {
  return {
    currentStageKey: null,
    stages: {},
    counters: {
      queued: 0,
      reading: 0,
      read: 0,
      grading: 0,
      assessed: 0,
      failed: 0,
      notSupplied: 0
    },
    documentsTotal: e,
    lastEventAt: (/* @__PURE__ */ new Date(0)).toISOString(),
    firstEventAt: (/* @__PURE__ */ new Date(0)).toISOString(),
    lastSeq: -1
  };
}
const an = d({
  min: m(),
  max: m()
}), Ts = d({
  hex: i(),
  // e.g., "#FF0000"
  themeVar: i()
  // e.g., "red.500"
}), $u = d({
  percentage: an,
  score: an,
  key: _(ln),
  label: d({
    en: i(),
    ar: i()
  }),
  level: x([
    g(0),
    g(1),
    g(2),
    g(3),
    g(4),
    g(5)
  ]),
  color: Ts
}), Pe = d({
  score: m().min(0).max(5),
  percentage: m().min(0).max(100),
  key: _(ln)
}), Cs = d({
  id: i(),
  name: i(),
  location: i()
}), Ns = d({
  id: i(),
  firstName: i(),
  lastName: i(),
  email: i(),
  username: i()
}), Ds = d({
  totalCount: m().int().min(0),
  criticalCount: m().int().min(0)
}), Ps = d({
  maturity: Pe,
  articlesAssessed: m().int().min(0),
  domainsCovered: m().int().min(0),
  gaps: Ds,
  missingDocuments: m().int().min(0),
  documentsAssessed: m().int().min(0)
}), Os = _(it), xs = d({
  id: i(),
  domainKey: i(),
  name: i(),
  description: i().nullable(),
  required: I(),
  weight: m(),
  minEstimatedTime: m(),
  maxEstimatedTime: m(),
  orderIndex: m()
}), Mn = d({
  id: i(),
  frameworkDomainId: i(),
  key: i(),
  version: i(),
  name: i(),
  description: i().nullable(),
  documentType: i().nullable(),
  orderIndex: m(),
  weight: m()
}), Us = d({
  id: i(),
  documentId: i(),
  fileName: i(),
  contentType: Os,
  fileSize: m(),
  s3Key: i(),
  uploadedById: i(),
  uploadedAt: i(),
  status: _(st),
  deleted: I(),
  standardDocument: Mn.nullable().default(null)
}), Ls = d({
  title: i(),
  description: i()
}), js = d({
  orderIndex: m(),
  title: i(),
  description: i()
}), Ms = d({
  orderIndex: m(),
  title: i()
}), Ks = d({
  maturity: Pe,
  gaps: m().int().min(0)
}), Fs = d({
  currentState: i().nullable().default(null),
  identifiedGaps: h(Ls).default([]),
  theRisk: i().nullable().default(null),
  whatIsNeeded: h(js).default([]),
  improvementPriorities: h(Ms).default([])
}), Gs = Ks.extend({
  analysis: Fs
}), Vs = d({
  maturity: Pe,
  gaps: m().int().min(0)
}), Ws = d({
  document: Us,
  results: Vs
}), Bs = d({
  id: i(),
  isSkipped: I(),
  isApplicable: I(),
  orderIndex: m()
}), qs = d({
  assessmentDomain: Bs,
  frameworkDomain: xs,
  results: Gs,
  documents: h(Ws).default([]),
  missingDocumentsList: h(Mn).default([])
}), Js = d({
  version: i(),
  workflowRunId: i(),
  completedAt: i(),
  tenant: Cs,
  user: Ns,
  overallResults: Ps
}), Hs = Js.extend({
  domains: h(qs)
});
var Xs = /* @__PURE__ */ ((e) => (e.Unchanged = "unchanged", e.Added = "added", e.Removed = "removed", e))(Xs || {});
const Ys = d({
  id: i(),
  s3Key: i(),
  fileName: i(),
  fileSize: m(),
  contentType: i(),
  uploadedAt: i(),
  uploadedById: i()
}), Tu = d({
  results: Hs.nullable(),
  reportDocument: Ys.nullable()
}), un = d({
  en: i(),
  ar: i()
}), Qs = d({
  documentKey: i(),
  documentName: i(),
  domainKey: i(),
  domainName: i(),
  /** Absolute pgvector cosine similarity in [0, 1] — not relative to other candidates. */
  score: m().min(0).max(1)
}), ea = d({
  classificationStatus: _(ue).default(
    ue.PENDING
  ),
  classificationConfidence: _(Ze).nullable(),
  reasoning: i().nullable(),
  language: i().nullable(),
  wordCount: m().int().nonnegative().nullable(),
  pageCount: m().int().nonnegative().nullable(),
  matchedStandardDocumentKey: i().nullable(),
  matchedStandardDocumentName: un.nullable(),
  matchedDomainKey: i().nullable(),
  matchedDomainName: un.nullable(),
  isRequiredDocumentMatch: I().nullable(),
  classifiedAt: me().nullable(),
  classificationStartedAt: me().nullable().default(null),
  classificationFailureReason: i().nullish().default(null),
  suggestedDomainKey: i().nullish().default(null),
  suggestedDocumentKey: i().nullish().default(null),
  suggestedDocumentName: i().nullish().default(null),
  suggestedDomainName: i().nullish().default(null),
  suggestedAiReasoning: i().nullish().default(null),
  suggestedConfidence: i().nullish().default(null),
  invalidReason: _(at).nullish().default(null),
  /** Ranked best-fit first. Empty for a clean single-document match. */
  candidateDocuments: h(Qs).nullish().default([]),
  coverage: _(dn).nullish().default(null),
  /** Expected sections of the matched document that are absent or empty. */
  missingSections: h(i()).nullish().default([])
}), Cu = ea.extend({
  classificationStatus: g(ue.COMPLETED).default(ue.COMPLETED),
  classificationConfidence: _(Ze),
  reasoning: i(),
  language: i(),
  isRequiredDocumentMatch: I(),
  classifiedAt: me(),
  classificationFailureReason: Ae().optional().default(null)
}), Kn = d({
  s3_key: i(),
  file_name: i(),
  domain_key: i(),
  matched_document_key: i().nullable(),
  matched_document_name: i().nullable(),
  confidence: _(Ze),
  reasoning: i(),
  language: i(),
  word_count: m().int().nonnegative().optional().nullable(),
  page_count: m().int().nonnegative().optional().nullable(),
  suggested_domain_key: i().nullable().optional(),
  suggested_document_key: i().nullable().optional(),
  suggested_document_name: i().nullable().optional(),
  suggested_domain_name: i().nullable().optional(),
  suggested_ai_reasoning: i().nullable().optional(),
  suggested_confidence: i().nullable().optional(),
  /**
   * Every other expected document in the domain besides the one matched above,
   * each measured — absolute pgvector cosine similarity in [0, 1] against the
   * uploaded file — and ranked best-fit first. Optional so a workflow deployed
   * before this field existed still validates.
   */
  candidates: h(
    d({
      document_key: i(),
      document_id: i(),
      document_name: i(),
      domain_key: i(),
      domain_name: i(),
      score: m().min(0).max(1)
    })
  ).optional().default([]).catch([]),
  coverage: _(dn).or(g("")).optional().nullable(),
  missing_sections: h(i()).optional().default([])
}), na = Kn.extend({
  id: G().optional(),
  error: i().nullable().optional()
}), Nu = Kn.extend({
  id: G()
}), ta = d({
  id: G(),
  s3_key: i(),
  error_code: i(),
  message: i()
}), Du = d({
  results: h(na),
  errors: h(ta).default([]),
  total_documents: m().int().nonnegative(),
  classified_documents: m().int().nonnegative(),
  total_cost: m().nonnegative(),
  total_tokens: m().int().nonnegative()
});
function oa(e) {
  return e.replace(/_([a-z0-9])/g, (n, t) => t.toUpperCase());
}
function Q(e) {
  return Ie(e);
}
function Ie(e) {
  if (Array.isArray(e))
    return e.map(Ie);
  if (!ra(e))
    return e;
  const n = {};
  for (const [t, o] of Object.entries(e))
    n[oa(t)] = Ie(o);
  return n;
}
function ra(e) {
  if (typeof e != "object" || e === null) return !1;
  const n = Object.getPrototypeOf(e);
  return n === Object.prototype || n === null;
}
const Pu = {
  LocalStorageStore: Symbol.for("LocalStorageStore"),
  CounterStore: Symbol.for("CounterStore"),
  AuthService: Symbol.for("AuthService"),
  ConversationsHistoryStore: Symbol.for("ConversationsHistoryStore"),
  StreamingStore: Symbol.for("StreamingStore")
}, Ou = h(
  d({
    // Stable, language-neutral section identifier (e.g. "OIM.introduction").
    // Required: the framework catalog input schema enforces section_key on
    // every section, so all seeded documents carry it.
    section_key: i(),
    section_name: d({
      [re.EN]: i(),
      [re.AR]: i()
    }),
    questions: d({
      [re.EN]: h(i()),
      [re.AR]: h(i())
    })
  })
), Fn = i(), Oe = i(), Gn = m(), Vn = i(), N = d({
  event: x([
    g("workflow_started"),
    g("workflow_finished"),
    g("node_started"),
    g("node_finished"),
    g("message"),
    g("message_end"),
    g("error"),
    g("file_ingest_progress"),
    g("assessment_started"),
    g("assessment_progress"),
    g("assessment_completed"),
    g("step_progress")
  ]),
  conversation_id: Fn,
  message_id: Oe,
  created_at: Gn,
  task_id: Vn
}), ia = N.extend({
  event: g("workflow_started"),
  data: d({
    id: i(),
    workflow_id: i()
    // Add other properties as needed
  })
}), sa = N.extend({
  event: g("workflow_finished"),
  data: d({
    status: x([g("succeeded"), i()]),
    outputs: d({
      answer: i()
    })
    // Add other properties as needed
  })
}), aa = N.extend({
  event: g("node_started"),
  data: d({
    id: i(),
    node_id: i(),
    node_type: i(),
    title: i()
    // Add other properties as needed
  })
}), ua = N.extend({
  event: g("node_finished"),
  data: d({
    id: i(),
    node_id: i(),
    node_type: i(),
    title: i(),
    status: x([g("succeeded"), i()])
    // Add other properties as needed
  })
}), ca = N.extend({
  event: g("message"),
  id: i(),
  answer: i(),
  from_variable_selector: h($())
  // Add other properties as needed
}), la = d({
  position: m(),
  dataset_id: i(),
  dataset_name: i(),
  document_id: i(),
  document_name: i(),
  segment_id: i(),
  retriever_from: i(),
  score: m(),
  hit_count: m(),
  word_count: m(),
  segment_position: m(),
  index_node_hash: i(),
  content: i(),
  // komplyanceAi can return null or a concrete value depending on dataset/index configuration.
  page: x([m(), i(), Ae()]).optional(),
  doc_metadata: T(i(), $()).default({}),
  title: x([i(), Ae()]).optional()
}), da = d({
  dimension: i(),
  score: m(),
  reasoning: i().optional().default("")
}), ma = d({
  verdict: _(["pass", "blocked"]),
  fallback_used: I().optional().default(!1),
  hard_fail_reasons: h(i()).optional().default([]),
  judge_error: i().optional(),
  score: d({
    total: m(),
    max: m(),
    pass_threshold: m(),
    evidence_limited: I().optional().default(!1),
    dimensions: h(da)
  }).optional()
}), ha = N.extend({
  event: g("message_end"),
  id: i(),
  message_id: Oe,
  metadata: d({
    retriever_resources: h(la),
    files: h($()).nullable().optional(),
    // Populated only by the Deep Research endpoint; absent on standard streams.
    quality_score: ma.optional()
    // Add other properties as needed
  })
}), fa = d({
  event: g("error"),
  err: i(),
  code: i().optional(),
  recoverable: I().optional(),
  retryAfter: m().optional(),
  conversation_id: Fn.optional().default(""),
  message_id: Oe.optional().default(""),
  created_at: Gn.optional().default(0),
  task_id: Vn.optional().default("")
}), pa = N.extend({
  event: g("file_ingest_progress"),
  data: d({
    stage: i(),
    message: i(),
    chunk_count: m().optional()
  })
}), _a = N.extend({
  event: g("assessment_started"),
  data: d({
    doc_id: i(),
    file_name: i()
  })
}), ga = N.extend({
  event: g("assessment_progress"),
  data: d({
    stage: i(),
    message: i(),
    current: m().optional(),
    total: m().optional()
  })
}), va = N.extend({
  event: g("assessment_completed"),
  data: $()
}), Sa = N.extend({
  event: g("step_progress"),
  data: d({
    stage: i(),
    message: i().optional().default("")
  })
}), xu = X("event", [
  ia,
  sa,
  aa,
  ua,
  ca,
  ha,
  fa,
  pa,
  _a,
  ga,
  va,
  Sa
]), Uu = /\[[A-Z0-9_]{2,60}\]/, Lu = 3, ju = 2, Wn = _([
  "heading",
  "paragraph",
  "list_item",
  "table",
  "diagram"
]), Bn = _(["bullet", "number"]), qn = _(["user", "ai"]), ba = _(["rendered", "placeholder"]), ka = d({
  headerRows: h(h(i())).default([]),
  rows: h(h(i())).default([])
}), wa = d({
  diagramId: i(),
  status: ba,
  pngKey: i().nullish().default(null),
  svgKey: i().nullish().default(null),
  width: m().int().nullish().default(null),
  height: m().int().nullish().default(null),
  /** Full DiagramSpec, kept verbatim for audit / re-render. Not interpreted here. */
  spec: T(i(), $()).nullish().default(null)
}), ya = d({
  blockId: i().min(1),
  kind: Wn,
  text: i().nullish().default(null),
  level: m().int().nullish().default(null),
  list: Bn.nullish().default(null),
  table: ka.nullish().default(null),
  diagram: wa.nullish().default(null),
  origin: qn.default("user"),
  sourcePage: m().int().nullish().default(null)
}), Ea = d({
  sectionKey: i().nullish().default(null),
  sectionName: i().min(1),
  blocks: h(ya).default([])
}), za = d({
  format: g("prose"),
  language: i(),
  documentKey: i(),
  domainKey: i(),
  sections: h(Ea).default([]),
  /** Every placeholder token present anywhere in the document. */
  placeholders: h(i()).default([])
}), Aa = d({
  columnKey: i().min(1),
  header: i(),
  order: m().int(),
  origin: qn.default("user")
}), Ia = d({
  rowId: i().min(1),
  order: m().int(),
  cells: T(i(), i()).default({})
}), Za = d({
  sheetId: i().min(1),
  /**
   * A display title, NOT an Excel worksheet name: on GENERATE the AI sets it to
   * the catalog document name, which is regularly longer than Excel's 31-char
   * tab cap and can contain characters a tab forbids (`/` among them); on
   * REWRITE it is the tab name read out of the tenant's own workbook. Render it
   * verbatim on screen, but never hand it to a spreadsheet library —
   * `resolveWorksheetName` in `remediation-xlsx.builder.ts` derives the tab name.
   */
  name: i(),
  columns: h(Aa).default([]),
  /**
   * GENERATE returns columns only (no rows); REWRITE carries the original rows
   * through untouched. Cell values are never modified by the AI — v1 remediates
   * columns only.
   */
  rows: h(Ia).default([])
}), Ra = d({
  format: g("spreadsheet"),
  language: i(),
  documentKey: i(),
  domainKey: i(),
  sheets: h(Za).default([]),
  placeholders: h(i()).default([])
}), Mu = X("format", [
  za,
  Ra
]), $a = _([
  "pdpl_law",
  "pdpl_ir",
  "catalog_section",
  "catalog_question",
  "prereq_field",
  "source_document"
]), xe = d({
  type: $a,
  key: i().min(1),
  label: i().min(1),
  excerpt: i().nullish().default(null)
}), Ta = d({
  changeId: i().min(1),
  type: _(["modification", "addition", "deletion"]),
  /** Stable anchor into `ProseSection.blocks` — reconstruction keys off this. */
  blockId: i().min(1),
  /**
   * Set on `addition` and `deletion`: insert (or re-insert on reject) directly
   * after this pre-existing block; null means the start of the section. Never
   * set on `modification`.
   */
  anchorBlockId: i().nullish().default(null),
  sectionKey: i().nullish().default(null),
  sectionName: i().min(1),
  /** Absent on `addition` — there was nothing there before. */
  before: i().nullish().default(null),
  /** Absent on `deletion` — there is nothing there after. */
  after: i().nullish().default(null),
  gapIds: h(i()).default([]),
  references: h(xe).default([]),
  containsPlaceholders: I().default(!1),
  placeholders: h(i()).default([]),
  /**
   * `deletion` only. `before` is plain text, which cannot by itself restore the
   * deleted block's structure — without these a rejected deletion of a heading
   * would come back as a paragraph. `table`/`diagram` cannot be restored from
   * text at all and degrade to a paragraph.
   */
  restoreKind: Wn.nullish().default(null),
  restoreLevel: m().int().nullish().default(null),
  restoreList: Bn.nullish().default(null),
  decision: _(O).default(O.PENDING)
}), Ca = d({
  changeId: i().min(1),
  type: _(["column_addition", "column_deletion"]),
  sheetId: i().min(1),
  columnKey: i().min(1),
  header: i().min(1),
  order: m().int(),
  /**
   * `column_deletion` only: how many populated cells the deletion drops, shown
   * to the user. A count, NOT a value backup — restoring a rejected deletion's
   * values requires re-reading the original upload.
   */
  beforeValuesCount: m().int().nullish().default(null),
  gapIds: h(i()).default([]),
  references: h(xe).default([]),
  containsPlaceholders: I().default(!1),
  placeholders: h(i()).default([]),
  decision: _(O).default(O.PENDING)
}), Na = d({
  mode: g("WHOLE_DOCUMENT"),
  decision: _(O).default(O.PENDING)
}), Da = d({
  mode: g("PROSE_CHANGES"),
  changes: h(Ta)
}), Pa = d({
  mode: g("SPREADSHEET_CHANGES"),
  changes: h(Ca)
}), Ku = X("mode", [
  Na,
  Da,
  Pa
]), Oa = [
  "non_canonical_section",
  "irrelevant_content",
  "garbage_content",
  "non_canonical_column",
  "low_confidence_extraction",
  "diagram_data_missing",
  "law_violation_unresolved",
  "figure_gap_unaddressed",
  "table_gap_unaddressed",
  "gap_unaddressed",
  "structure_integrity_violation",
  "toc_replaced"
], xa = d({
  flagId: i().min(1),
  /**
   * A flag is advisory-only metadata — it never gates whether a document is
   * usable, unlike `document`/`changeSet`. Rejecting an entire item because
   * its `type` label is one this schema version doesn't recognise would
   * trade a perfectly good, reviewable document for a hard failure over an
   * FYI field. So an unrecognised value is preserved as a plain string
   * (the UI still has the free-text `note` to fall back on) instead of
   * failing validation; `KNOWN_FLAG_TYPES` still gives callers a
   * discriminable, typed set to switch on for the values this version does
   * recognise.
   */
  type: x([_(Oa), i().min(1)]),
  /** `<blockId>` | `section:<name>` | `column:<columnKey>` | `sheet:<sheetId>`. */
  target: i().min(1),
  /** Human-readable, in the item's language. */
  note: i().min(1)
}), Ua = d({
  verdict: _(["pass", "warn"]),
  scores: T(i(), m()).default({}),
  notes: h(i()).default([]),
  lowConfidenceSections: h(i()).default([])
}), cn = d({
  articleLabel: i(),
  type: i(),
  sectionKeys: h(i()).default([])
}), La = d({
  judge: Ua.nullish().default(null),
  clauseCoverage: d({
    covered: h(cn).default([]),
    unaddressed: h(cn).default([])
  }).nullish().default(null),
  placeholders: d({
    total: m().int().default(0),
    /**
     * Always empty in the current AI build — the registry backing it is seeded
     * empty by design in v1. Do NOT gate finalize on this being empty; it
     * cannot fire yet.
     */
    compulsoryUnresolved: h(i()).default([])
  }).nullish().default(null)
}), ja = d({
  bullets: h(i()).default([]),
  /** Deterministic tally: `added` / `deleted` / `modified` / `flagged`. */
  counts: T(i(), m()).default({}),
  /**
   * False means the LLM phrasing step failed and `bullets` is a plainer
   * template-generated fallback — still accurate, just less polished.
   * Informational; nothing needs to branch on it.
   */
  narrated: I().default(!1)
}), Ma = d({
  token: i().min(1),
  label: i(),
  locations: h(i()).default([]),
  changeIds: h(i()).default([]),
  gapIds: h(i()).default([])
}), Ka = T(i(), h(xe)), Fa = d({
  flags: h(xa).default([]),
  validation: La.nullish().default(null),
  changeSummary: ja.nullish().default(null),
  placeholdersToFill: h(Ma).default([]),
  sectionReferences: Ka.nullish().default(null)
}), Fu = _([
  "ASSESSMENT_ARTIFACTS_UNAVAILABLE",
  "SOURCE_DOWNLOAD_FAILED",
  "EXTRACTION_FAILED",
  "UNSUPPORTED_FORMAT",
  "CATALOG_DOCUMENT_NOT_FOUND",
  "GENERATION_FAILED",
  "LLM_UNAVAILABLE"
]), Jn = _(["GENERATE", "REWRITE"]);
function Gu(e) {
  return e === ce.GENERATE ? "GENERATE" : "REWRITE";
}
function Ga(e) {
  return e === "GENERATE" ? ce.GENERATE : ce.REMEDIATE;
}
const Va = _(["prose", "spreadsheet"]);
function Vu(e) {
  return e === "prose" ? ke.PROSE : ke.SPREADSHEET;
}
const Wa = d({
  header_rows: h(h(i())).default([]),
  rows: h(h(i())).default([])
}), Ba = d({
  diagram_id: i(),
  status: _(["rendered", "placeholder"]),
  png_key: i().nullish(),
  svg_key: i().nullish(),
  width: m().int().nullish(),
  height: m().int().nullish(),
  spec: T(i(), $()).nullish()
}), qa = d({
  block_id: i().min(1),
  kind: _(["heading", "paragraph", "list_item", "table", "diagram"]),
  text: i().nullish(),
  level: m().int().nullish(),
  list: _(["bullet", "number"]).nullish(),
  table: Wa.nullish(),
  diagram: Ba.nullish(),
  origin: _(["user", "ai"]).default("user"),
  source_page: m().int().nullish()
}), Ja = d({
  // Null for non-canonical content, and repeatable within one document.
  section_key: i().nullish(),
  section_name: i().min(1),
  blocks: h(qa).default([])
}), Ha = d({
  format: g("prose"),
  language: i(),
  document_key: i(),
  domain_key: i(),
  sections: h(Ja).default([]),
  placeholders: h(i()).default([])
}), Xa = d({
  column_key: i().min(1),
  header: i(),
  order: m().int(),
  origin: _(["user", "ai"]).default("user")
}), Ya = d({
  row_id: i().min(1),
  order: m().int(),
  cells: T(i(), i()).default({})
}), Qa = d({
  sheet_id: i().min(1),
  name: i(),
  columns: h(Xa).default([]),
  rows: h(Ya).default([])
}), eu = d({
  format: g("spreadsheet"),
  language: i(),
  document_key: i(),
  domain_key: i(),
  sheets: h(Qa).default([]),
  placeholders: h(i()).default([])
}), nu = X("format", [
  Ha,
  eu
]), Hn = d({
  type: _([
    "pdpl_law",
    "pdpl_ir",
    "catalog_section",
    "catalog_question",
    "prereq_field",
    "source_document"
  ]),
  key: i().min(1),
  label: i().min(1),
  excerpt: i().nullish()
}), tu = d({
  change_id: i().min(1),
  type: _(["modification", "addition", "deletion"]),
  block_id: i().min(1),
  anchor_block_id: i().nullish(),
  section_key: i().nullish(),
  section_name: i().min(1),
  before: i().nullish(),
  after: i().nullish(),
  gap_ids: h(i()).default([]),
  references: h(Hn).default([]),
  contains_placeholders: I().default(!1),
  placeholders: h(i()).default([]),
  restore_kind: _(["heading", "paragraph", "list_item", "table", "diagram"]).nullish(),
  restore_level: m().int().nullish(),
  restore_list: _(["bullet", "number"]).nullish()
}), ou = d({
  change_id: i().min(1),
  type: _(["column_addition", "column_deletion"]),
  sheet_id: i().min(1),
  column_key: i().min(1),
  header: i().min(1),
  order: m().int(),
  before_values_count: m().int().nullish(),
  gap_ids: h(i()).default([]),
  references: h(Hn).default([]),
  contains_placeholders: I().default(!1),
  placeholders: h(i()).default([])
}), ru = x([tu, ou]), iu = d({
  changes: h(ru).default([])
}), su = d({
  flag_id: i().min(1),
  type: i(),
  target: i().min(1),
  note: i().min(1)
}), Xn = d({
  item_id: i(),
  type: Jn,
  content_kind: Va.nullish(),
  status: _(["completed", "failed"]),
  error_code: i().nullish(),
  error_detail: i().nullish(),
  document: nu.nullish(),
  /**
   * `null` for GENERATE and failed items. `{ changes: [] }` is a DIFFERENT and
   * deliberate signal — a REWRITE that genuinely produced no changes.
   */
  change_set: iu.nullish(),
  flags: h(su).default([]),
  validation: T(i(), $()).nullish(),
  change_summary: T(i(), $()).nullish(),
  placeholders_to_fill: h(T(i(), $())).default([]),
  section_references: T(i(), $()).nullish(),
  /**
   * The raw extracted text of the SOURCE document a REWRITE ran against, before
   * any canonicalization. `document` is the improved version, so without this
   * the original is unrecoverable and no whole-document before/after is possible.
   * Null for GENERATE, spreadsheet and failed items.
   */
  source_text: i().nullish()
}), au = M({
  correlationId: G().optional()
}), uu = d({
  /** Echoed from the request — the backend mints it, the AI does not. */
  workflow_run_id: i().nullish(),
  remediation_run_id: i(),
  outbox_id: i().nullish(),
  status: _(["completed", "failed"]),
  items: h(Xn).default([]),
  failure_reason: i().nullish(),
  /** The Job's failure payload uses `error` where the service uses `failure_reason`. */
  error: i().nullish(),
  metadata: au.optional()
});
function Wu(e) {
  const n = uu.safeParse(e);
  return n.success ? { success: !0, data: n.data } : { success: !1, error: n.error };
}
function Yn(e) {
  return {
    type: e.type,
    key: e.key,
    label: e.label,
    excerpt: e.excerpt ?? null
  };
}
function Bu(e) {
  return e.format === "prose" ? {
    format: "prose",
    language: e.language,
    documentKey: e.document_key,
    domainKey: e.domain_key,
    placeholders: e.placeholders,
    sections: e.sections.map((n) => ({
      sectionKey: n.section_key ?? null,
      sectionName: n.section_name,
      blocks: n.blocks.map((t) => ({
        blockId: t.block_id,
        kind: t.kind,
        text: t.text ?? null,
        level: t.level ?? null,
        list: t.list ?? null,
        table: t.table ? { headerRows: t.table.header_rows, rows: t.table.rows } : null,
        diagram: t.diagram ? {
          diagramId: t.diagram.diagram_id,
          status: t.diagram.status,
          pngKey: t.diagram.png_key ?? null,
          svgKey: t.diagram.svg_key ?? null,
          width: t.diagram.width ?? null,
          height: t.diagram.height ?? null,
          spec: t.diagram.spec ?? null
        } : null,
        origin: t.origin,
        sourcePage: t.source_page ?? null
      }))
    }))
  } : {
    format: "spreadsheet",
    language: e.language,
    documentKey: e.document_key,
    domainKey: e.domain_key,
    placeholders: e.placeholders,
    sheets: e.sheets.map((n) => ({
      sheetId: n.sheet_id,
      name: n.name,
      columns: n.columns.map((t) => ({
        columnKey: t.column_key,
        header: t.header,
        order: t.order,
        origin: t.origin
      })),
      rows: n.rows.map((t) => ({
        rowId: t.row_id,
        order: t.order,
        cells: t.cells
      }))
    }))
  };
}
const cu = /* @__PURE__ */ new Set(["modification", "addition", "deletion"]);
function Qn(e) {
  return cu.has(e.type);
}
function lu(e) {
  return {
    changeId: e.change_id,
    type: e.type,
    blockId: e.block_id,
    anchorBlockId: e.anchor_block_id ?? null,
    sectionKey: e.section_key ?? null,
    sectionName: e.section_name,
    before: e.before ?? null,
    after: e.after ?? null,
    gapIds: e.gap_ids,
    references: e.references.map(Yn),
    containsPlaceholders: e.contains_placeholders,
    placeholders: e.placeholders,
    restoreKind: e.restore_kind ?? null,
    restoreLevel: e.restore_level ?? null,
    restoreList: e.restore_list ?? null,
    decision: O.PENDING
  };
}
function du(e) {
  if (Qn(e))
    throw new Error(`Unexpected spreadsheet change type: ${JSON.stringify(e)}`);
  return {
    changeId: e.change_id,
    type: e.type,
    sheetId: e.sheet_id,
    columnKey: e.column_key,
    header: e.header,
    order: e.order,
    beforeValuesCount: e.before_values_count ?? null,
    gapIds: e.gap_ids,
    references: e.references.map(Yn),
    containsPlaceholders: e.contains_placeholders,
    placeholders: e.placeholders,
    decision: O.PENDING
  };
}
function qu(e, n) {
  var o;
  if (Ga(e.type) === ce.GENERATE)
    return {
      mode: "WHOLE_DOCUMENT",
      decision: O.PENDING
    };
  const t = ((o = e.change_set) == null ? void 0 : o.changes) ?? [];
  return n.format === "spreadsheet" ? {
    mode: "SPREADSHEET_CHANGES",
    changes: t.map(du)
  } : {
    mode: "PROSE_CHANGES",
    changes: t.map((r) => {
      if (!Qn(r))
        throw new Error(`Unexpected prose change type: ${JSON.stringify(r)}`);
      return lu(r);
    })
  };
}
function Ju(e) {
  return Fa.parse({
    flags: Q(e.flags),
    validation: e.validation ? Q(e.validation) : null,
    changeSummary: e.change_summary ? Q(e.change_summary) : null,
    placeholdersToFill: Q(e.placeholders_to_fill),
    sectionReferences: e.section_references ? Q(e.section_references) : null
  });
}
const Ue = {
  /** Minted by us, echoed by the AI. Required — see the header. */
  workflow_run_id: i().min(1),
  remediation_run_id: i().min(1),
  outbox_id: i().nullish(),
  metadata: M({ correlationId: G().optional() }).optional()
}, mu = ["started", "completed", "failed"], hu = _(mu), fu = d({
  kind: g("item_progress"),
  ...Ue,
  item_id: i().min(1),
  state: hu
}), pu = Xn.extend({
  kind: g("item"),
  ...Ue,
  /**
   * The item's zero-based position in the dispatched request's `items[]`.
   *
   * A cross-check, not the identifier. The AI already carries a fix for routing
   * results by `itemId`: a `{item_id: wire}` map silently collapsed two items
   * that shared an id (or both lacked one), returning fewer items than requested
   * with no error. Sending the index alongside lets the receiver detect that
   * class instead of persisting one document over another.
   */
  item_index: m().int().nonnegative()
}), _u = d({
  item_id: i().min(1),
  item_index: m().int().nonnegative(),
  status: _(["completed", "failed"]),
  error_code: i().nullish(),
  error_detail: i().nullish()
}), gu = d({
  kind: g("summary"),
  ...Ue,
  /** Run-level outcome. `failed` means the run aborted, NOT that every item failed. */
  status: _(["completed", "failed"]),
  failure_reason: i().nullish(),
  /** The Job's failure payload uses `error` where the service uses `failure_reason`. */
  error: i().nullish(),
  items: h(_u).default([]),
  /**
   * Documents the Job was handed and never began.
   *
   * SERVING THE PAYLOAD CLAIMS THE WORK, so every document in a Job's batch is
   * PROCESSING and claimed to it from the moment it is served — which makes a
   * document the Job stopped short of indistinguishable, to the receiver, from
   * one it started and lost. The receiver reconciles the latter by failing it,
   * and so it failed both: a container that stopped at its own deadline to leave
   * the rest for the next execution had that remainder written off instead.
   *
   * Naming them is the difference. An id here means "still owed, nothing spent
   * on it" — the receiver returns it to the queue rather than failing it.
   * Defaults to empty, so a Job that predates the field reconciles exactly as
   * it did.
   */
  unstarted: h(i().min(1)).default([]),
  totals: d({
    requested: m().int().nonnegative(),
    completed: m().int().nonnegative(),
    failed: m().int().nonnegative()
  }).optional()
}), vu = X("kind", [
  fu,
  pu,
  gu
]), Hu = M({
  kind: _(["item_progress", "item", "summary"]),
  workflow_run_id: i().min(1),
  remediation_run_id: i().min(1),
  outbox_id: i().nullish(),
  item_id: i().min(1).optional(),
  metadata: M({ correlationId: G().optional() }).optional()
});
function Xu(e) {
  switch (e.kind) {
    case "item":
      return e.item_id ? `${e.workflow_run_id}:item:${e.item_id}` : null;
    case "summary":
      return `${e.workflow_run_id}:summary`;
    case "item_progress":
      return null;
    default: {
      const n = e.kind;
      throw new Error(`Unhandled callback kind: ${String(n)}`);
    }
  }
}
function Yu(e) {
  return e.failure_reason ?? e.error ?? null;
}
function Qu(e) {
  const n = vu.safeParse(e);
  return n.success ? { success: !0, data: n.data } : { success: !1, error: JSON.stringify(n.error.issues) };
}
const Su = d({
  documentId: i(),
  /** Keys the AI's per-document `remediation_input.json` artifact. Required for REWRITE. */
  assessmentDomainDocumentId: i(),
  /** Short-lived presigned GET url for the original upload — NOT an s3 key. */
  downloadUrl: i(),
  maturityPct: m().nullable().default(null),
  /**
   * The user's gap selection. Omitted or empty means "remediate every gap for
   * this document", which is the right default until a gap-picker UI exists.
   * Values come from the assessment result webhook's
   * `assessment_domain_documents_results[].gaps[].gap_id`.
   */
  gapIds: h(i()).optional()
}), bu = d({
  itemId: i(),
  /** Wire vocabulary — use `toWireItemType()` to convert from the internal enum. */
  type: Jn,
  contentKind: _(ke),
  domainKey: i(),
  standardDocumentKey: i(),
  // Present for REWRITE only; the AI parses the source itself.
  sourceDocument: Su.optional()
}), ku = d({
  /** Accepted but ignored by the AI (it owns a catalog cache). */
  catalogUrl: i(),
  /** Accepted but ignored by the AI (it owns a tenant-values endpoint). */
  profileUrl: i(),
  correlationId: i()
}), ec = d({
  /** Backend-minted, echoed back on the result envelope. See the file header. */
  workflowRunId: i(),
  remediationRunId: i(),
  /**
   * The assessment being remediated — this version's own id.
   *
   * `parentAssessmentId` and `assessmentVersion` accompany it because the AI's
   * artifact store is keyed by *lineage*: everything lives under the root id at
   * `v{N}/`, while this id changes with every version. Without the pair, a
   * versioned assessment's `remediation_input` cannot be found (it resolves by
   * luck on v1, where the two ids are the same).
   */
  assessmentId: i(),
  parentAssessmentId: i(),
  assessmentVersion: m().int().positive(),
  tenantId: i(),
  language: _(ut),
  items: h(bu),
  metadata: ku
}), nc = Symbol("S3_CLIENT"), tc = Symbol("GCS_CLIENT"), oc = 300, rc = 3600;
var wu = /* @__PURE__ */ ((e) => (e.EXTRACT = "EXTRACT", e.MAP = "MAP", e.TRANSFORM = "TRANSFORM", e.PARAPHRASE = "PARAPHRASE", e.STRUCTURE = "STRUCTURE", e.DIRECT = "DIRECT", e.REFERENCE = "REFERENCE", e))(wu || {}), yu = /* @__PURE__ */ ((e) => (e.STRING = "string", e.TEXTAREA = "textarea", e.NUMBER = "number", e.BOOLEAN = "boolean", e.DATE = "date", e.EMAIL = "email", e.PHONE = "phone", e.FILE = "file", e.REFERENCE = "reference", e.SELECT = "select", e.MULTI_SELECT = "multi_select", e.NUMBER_LIST = "number_list", e.STRING_LIST = "string_list", e.TABLE = "table", e))(yu || {}), Eu = /* @__PURE__ */ ((e) => (e.PENDING = "pending", e.CONFIRMED = "confirmed", e.DELETED = "deleted", e))(Eu || {});
const ic = d({
  status: is(we).default(we.PENDING),
  attempts: m().int().nonnegative().default(0),
  // Result fields populated by the handler on terminal states.
  verdict: _(["valid", "invalid"]).nullable().default(null),
  reasonCode: i().nullable().default(null),
  reasonText: i().nullable().default(null),
  // The category the AI matched the document to (from our seeded catalog).
  // Plain output of classification — not a user-facing recommendation.
  detectedCategoryKey: i().nullable().default(null),
  confidence: _(["high", "medium", "low"]).nullable().default(null),
  language: i().nullable().default(null),
  wordCount: m().int().nonnegative().nullable().default(null),
  pageCount: m().int().nonnegative().nullable().default(null),
  // Telemetry.
  startedAt: i().datetime().nullable().default(null),
  classifiedAt: i().datetime().nullable().default(null),
  lastError: i().nullable().default(null)
}), sc = d({
  status: _(ye).default(ye.NOT_STARTED),
  attempts: m().int().nonnegative().default(0),
  extractedFieldCount: m().int().nonnegative().nullable().default(null),
  aiNotes: i().nullable().default(null),
  startedAt: i().datetime().nullable().default(null),
  completedAt: i().datetime().nullable().default(null),
  lastError: i().nullable().default(null)
}), ac = {
  status: we.PENDING,
  attempts: 0,
  verdict: null,
  reasonCode: null,
  reasonText: null,
  detectedCategoryKey: null,
  confidence: null,
  language: null,
  wordCount: null,
  pageCount: null,
  startedAt: null,
  classifiedAt: null,
  lastError: null
}, uc = {
  status: ye.NOT_STARTED,
  attempts: 0,
  extractedFieldCount: null,
  aiNotes: null,
  startedAt: null,
  completedAt: null,
  lastError: null
};
export {
  Is as ASSESSMENT_PROGRESS_KINDS,
  Zs as ASSESSMENT_RESULT_KIND,
  Os as AllowedDocumentContentTypeSchema,
  As as AssessmentDocumentProgressCallbackSchema,
  zs as AssessmentDocumentProgressDetailSchema,
  Us as AssessmentDomainDocumentSchema,
  Au as AssessmentProgressCallbackSchema,
  Zu as AssessmentProgressSnapshotSchema,
  Js as AssessmentResultsBaseSchema,
  Hs as AssessmentResultsMetaSchema,
  Es as AssessmentStageProgressCallbackSchema,
  ys as AssessmentStageProgressDetailSchema,
  Nu as AsyncClassificationResultSchema,
  Wn as BlockKindSchema,
  qn as BlockOriginSchema,
  ta as ClassificationErrorSchema,
  ic as ClassificationMetadataSchema,
  Du as ClassifyDocumentsAiResponseSchema,
  Cu as CompletedDocumentClassificationMetadataSchema,
  Fn as ConversationIdSchema,
  ac as DEFAULT_CLASSIFICATION_METADATA,
  uc as DEFAULT_EXTRACTION_METADATA,
  wa as DiagramBlockSchema,
  ba as DiagramStatusSchema,
  Qs as DocumentClassificationCandidateSchema,
  ea as DocumentClassificationMetadataSchema,
  Vs as DocumentResultsSchema,
  Fs as DomainAnalysisSchema,
  Xs as DomainDocumentComparisonChangeType,
  Ws as DomainDocumentResultEntrySchema,
  qs as DomainResultEntrySchema,
  Gs as DomainResultsDetailSchema,
  Ks as DomainResultsSchema,
  Mn as DomainStandardDocumentSchema,
  Bs as EmbeddedAssessmentDomainSchema,
  sc as ExtractionMetadataSchema,
  tc as GCS_CLIENT,
  Tu as GetAssessmentResultsResponseSchema,
  Oa as KNOWN_FLAG_TYPES,
  va as KomplyanceAiAssessmentCompletedChunkSchema,
  ga as KomplyanceAiAssessmentProgressChunkSchema,
  _a as KomplyanceAiAssessmentStartedChunkSchema,
  N as KomplyanceAiBaseDataChunkSchema,
  xu as KomplyanceAiChunkSchema,
  pa as KomplyanceAiFileIngestProgressChunkSchema,
  fa as KomplyanceAiInvalidChunkSchema,
  ca as KomplyanceAiMessageChunkSchema,
  ha as KomplyanceAiMessageEndChunkSchema,
  la as KomplyanceAiMessageEndRetrieverResourceSchema,
  ua as KomplyanceAiNodeFinishedChunkSchema,
  aa as KomplyanceAiNodeStartedChunkSchema,
  da as KomplyanceAiQualityDimensionScoreSchema,
  ma as KomplyanceAiQualityScoreMetadataSchema,
  Sa as KomplyanceAiStepProgressChunkSchema,
  sa as KomplyanceAiWorkflowFinishedChunkSchema,
  ia as KomplyanceAiWorkflowStartedChunkSchema,
  Bn as ListStyleSchema,
  Lu as MAX_HEADING_LEVEL,
  ju as MAX_LIST_LEVEL,
  $u as MaturitySchema,
  Oe as MessageIdSchema,
  Ps as OverallResultsSchema,
  Uu as PLACEHOLDER_TOKEN_PATTERN,
  Ma as PlaceholderToFillSchema,
  wu as ProfileFieldFeedTransformation,
  yu as ProfileFieldType,
  $s as ProgressCountersSchema,
  ya as ProseBlockSchema,
  Ta as ProseChangeSchema,
  Da as ProseChangeSetSchema,
  za as ProseDocumentSchema,
  Ea as ProseSectionSchema,
  mu as REMEDIATION_ITEM_PROGRESS_STATES,
  Eu as ReferenceAttachmentStatus,
  xe as ReferenceSchema,
  $a as ReferenceTypeSchema,
  Fa as RemediationAiMetadataSchema,
  Hu as RemediationCallbackRoutingSchema,
  vu as RemediationCallbackSchema,
  Ku as RemediationChangeSetSchema,
  ja as RemediationChangeSummarySchema,
  cn as RemediationClauseRefSchema,
  Fu as RemediationErrorCodeSchema,
  xa as RemediationFlagSchema,
  Mu as RemediationGeneratedContentSchema,
  pu as RemediationItemCallbackSchema,
  fu as RemediationItemProgressCallbackSchema,
  hu as RemediationItemProgressStateSchema,
  Ua as RemediationJudgeSchema,
  bu as RemediationRequestItemSchema,
  ku as RemediationRequestMetadataSchema,
  ec as RemediationRequestSchema,
  Su as RemediationRequestSourceDocumentSchema,
  Xn as RemediationResultItemSchema,
  gu as RemediationRunSummaryCallbackSchema,
  La as RemediationValidationSchema,
  uu as RemediationWorkerRunResponseSchema,
  Ys as ReportDocumentSchema,
  Ds as ResultsGapsSummarySchema,
  Pe as ResultsMaturitySchema,
  Cs as ResultsTenantSchema,
  Ns as ResultsUserSchema,
  nc as S3_CLIENT,
  rc as S3_DOWNLOAD_PRESIGNED_URL_EXPIRY,
  oc as S3_UPLOAD_PRESIGNED_URL_EXPIRY,
  Ka as SectionReferencesSchema,
  Ca as SpreadsheetChangeSchema,
  Pa as SpreadsheetChangeSetSchema,
  Aa as SpreadsheetColumnSchema,
  Ra as SpreadsheetDocumentSchema,
  Ia as SpreadsheetRowSchema,
  Za as SpreadsheetSheetSchema,
  Rs as StageProgressSchema,
  Ou as StandardDocumentQuestionsSchema,
  na as SyncClassificationResultSchema,
  Pu as TYPES,
  ka as TableDataSchema,
  Vn as TaskIdSchema,
  Gn as TimestampSchema,
  Na as WholeDocumentChangeSetSchema,
  Va as WireContentKindSchema,
  Jn as WireItemTypeSchema,
  Ju as buildAiMetadata,
  qu as buildChangeSet,
  Xu as callbackDedupeKey,
  Q as camelizeKeys,
  Ru as emptyProgressSnapshot,
  Vu as fromWireContentKind,
  Ga as fromWireItemType,
  Bu as mapDocumentToGeneratedContent,
  Qu as parseRemediationCallback,
  Wu as parseRemediationWorkerRunResponse,
  Iu as resolveAssessmentCallbackKind,
  oa as snakeToCamel,
  Yu as summaryFailureReason,
  Gu as toWireItemType
};
